// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Nike TG";
  font-style: normal;
  font-weight: 400;
  src: url(//assets.commerce.nikecloud.com/ncss/0.17/dotcom/fonts/257c802f-349c-4b4d-aefa-546d5de15ec6.eot);
  src: url(//assets.commerce.nikecloud.com/ncss/0.17/dotcom/fonts/257c802f-349c-4b4d-aefa-546d5de15ec6.eot?#iefix) format("embedded-opentype"), url(//assets.commerce.nikecloud.com/ncss/0.17/dotcom/fonts/257c802f-349c-4b4d-aefa-546d5de15ec6.woff) format("woff"), url(//assets.commerce.nikecloud.com/ncss/0.17/dotcom/fonts/257c802f-349c-4b4d-aefa-546d5de15ec6.ttf) format("truetype"), url(//assets.commerce.nikecloud.com/ncss/0.17/dotcom/fonts/257c802f-349c-4b4d-aefa-546d5de15ec6.svg#257c802f-349c-4b4d-aefa-546d5de15ec6) format("svg");
}
@font-face {
  font-family: "Nike Futura";
  font-style: normal;
  font-weight: 400;
  src: url(//assets.commerce.nikecloud.com/ncss/0.17/dotcom/fonts/3de3fe6a-5eb5-46c0-b860-817dac7636b1.eot);
  src: url(//assets.commerce.nikecloud.com/ncss/0.17/dotcom/fonts/3de3fe6a-5eb5-46c0-b860-817dac7636b1.eot?#iefix) format("embedded-opentype"), url(//assets.commerce.nikecloud.com/ncss/0.17/dotcom/fonts/3de3fe6a-5eb5-46c0-b860-817dac7636b1.woff) format("woff"), url(//assets.commerce.nikecloud.com/ncss/0.17/dotcom/fonts/3de3fe6a-5eb5-46c0-b860-817dac7636b1.ttf) format("truetype"), url(//assets.commerce.nikecloud.com/ncss/0.17/dotcom/fonts/3de3fe6a-5eb5-46c0-b860-817dac7636b1.svg#3de3fe6a-5eb5-46c0-b860-817dac7636b1) format("svg");
}
.ua-ncss a, .ua-ncss abbr, .ua-ncss acronym, .ua-ncss address, .ua-ncss applet, .ua-ncss article, .ua-ncss aside, .ua-ncss audio, .ua-ncss b, .ua-ncss big, .ua-ncss blockquote, .ua-ncss body, .ua-ncss canvas, .ua-ncss caption, .ua-ncss center, .ua-ncss cite, .ua-ncss code, .ua-ncss dd, .ua-ncss del, .ua-ncss details, .ua-ncss dfn, .ua-ncss div, .ua-ncss dl, .ua-ncss dt, .ua-ncss em, .ua-ncss embed, .ua-ncss fieldset, .ua-ncss figcaption, .ua-ncss figure, .ua-ncss footer, .ua-ncss form, .ua-ncss h1, .ua-ncss h2, .ua-ncss h3, .ua-ncss h4, .ua-ncss h5, .ua-ncss h6, .ua-ncss header, .ua-ncss hgroup, .ua-ncss html, .ua-ncss i, .ua-ncss iframe, .ua-ncss img, .ua-ncss ins, .ua-ncss kbd, .ua-ncss label, .ua-ncss legend, .ua-ncss li, .ua-ncss mark, .ua-ncss menu, .ua-ncss nav, .ua-ncss object, .ua-ncss ol, .ua-ncss output, .ua-ncss p, .ua-ncss pre, .ua-ncss q, .ua-ncss ruby, .ua-ncss s, .ua-ncss samp, .ua-ncss section, .ua-ncss small, .ua-ncss span, .ua-ncss strike, .ua-ncss strong, .ua-ncss sub, .ua-ncss summary, .ua-ncss sup, .ua-ncss table, .ua-ncss tbody, .ua-ncss td, .ua-ncss tfoot, .ua-ncss th, .ua-ncss thead, .ua-ncss time, .ua-ncss tr, .ua-ncss tt, .ua-ncss u, .ua-ncss ul, .ua-ncss var, .ua-ncss video {
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit;
  vertical-align: baseline;
}

.ua-ncss article, .ua-ncss aside, .ua-ncss details, .ua-ncss figcaption, .ua-ncss figure, .ua-ncss footer, .ua-ncss header, .ua-ncss hgroup, .ua-ncss img, .ua-ncss menu, .ua-ncss nav, .ua-ncss section {
  display: block;
}

.ua-ncss ol, .ua-ncss ul {
  list-style: none;
}

.ua-ncss blockquote, .ua-ncss q {
  quotes: none;
}

.ua-ncss blockquote:after, .ua-ncss blockquote:before, .ua-ncss q:after, .ua-ncss q:before {
  content: "";
  content: none;
}

.ua-ncss table {
  border-collapse: collapse;
  border-spacing: 0;
}

.ua-ncss a:active, .ua-ncss a:hover {
  outline: 0;
}

.ua-ncss body, .ua-ncss html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ua-ncss .ncss-base {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 400;
}

.ua-ncss .ncss-brand {
  font-family: "Nike TG", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 400;
  letter-spacing: 0.5px;
}

.ua-ncss .ncss-marketing {
  font-family: "Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 400;
}

.ua-ncss .p, .ua-ncss p {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 1.7142857143;
}

.ua-ncss .small, .ua-ncss small {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 2;
}

.ua-ncss .fs10-sm {
  font-size: 10px;
  line-height: 2.4;
}

.ua-ncss .fs12-sm {
  font-size: 12px;
  line-height: 2;
}

.ua-ncss .fs14-sm {
  font-size: 14px;
  line-height: 1.7142857143;
}

.ua-ncss .fs16-sm {
  font-size: 16px;
  line-height: 1.5;
}

.ua-ncss .fs18-sm {
  font-size: 18px;
  line-height: 1.3333333333;
}

.ua-ncss .fs20-sm {
  font-size: 20px;
  line-height: 1.2;
}

.ua-ncss .fs22-sm {
  font-size: 22px;
  line-height: 1.0909090909;
}

.ua-ncss .fs24-sm {
  font-size: 24px;
  line-height: 1;
}

.ua-ncss .fs26-sm {
  font-size: 26px;
  line-height: 1.8461538462;
}

.ua-ncss .fs28-sm {
  font-size: 28px;
  line-height: 1.7142857143;
}

.ua-ncss .fs30-sm {
  font-size: 30px;
  line-height: 1.6;
}

.ua-ncss .fs32-sm {
  font-size: 32px;
  line-height: 1.5;
}

.ua-ncss .fs34-sm {
  font-size: 34px;
  line-height: 1.4117647059;
}

.ua-ncss .fs36-sm {
  font-size: 36px;
  line-height: 1.3333333333;
}

.ua-ncss .fs38-sm {
  font-size: 38px;
  line-height: 1.2631578947;
}

.ua-ncss .fs40-sm {
  font-size: 40px;
  line-height: 1.2;
}

@media only screen and (min-width: 640px) {
  .ua-ncss .fs10-md {
    font-size: 10px;
    line-height: 2.4;
  }
  .ua-ncss .fs12-md {
    font-size: 12px;
    line-height: 2;
  }
  .ua-ncss .fs14-md {
    font-size: 14px;
    line-height: 1.7142857143;
  }
  .ua-ncss .fs16-md {
    font-size: 16px;
    line-height: 1.5;
  }
  .ua-ncss .fs18-md {
    font-size: 18px;
    line-height: 1.3333333333;
  }
  .ua-ncss .fs20-md {
    font-size: 20px;
    line-height: 1.2;
  }
  .ua-ncss .fs22-md {
    font-size: 22px;
    line-height: 1.0909090909;
  }
  .ua-ncss .fs24-md {
    font-size: 24px;
    line-height: 1;
  }
  .ua-ncss .fs26-md {
    font-size: 26px;
    line-height: 1.8461538462;
  }
  .ua-ncss .fs28-md {
    font-size: 28px;
    line-height: 1.7142857143;
  }
  .ua-ncss .fs30-md {
    font-size: 30px;
    line-height: 1.6;
  }
  .ua-ncss .fs32-md {
    font-size: 32px;
    line-height: 1.5;
  }
  .ua-ncss .fs34-md {
    font-size: 34px;
    line-height: 1.4117647059;
  }
  .ua-ncss .fs36-md {
    font-size: 36px;
    line-height: 1.3333333333;
  }
  .ua-ncss .fs38-md {
    font-size: 38px;
    line-height: 1.2631578947;
  }
  .ua-ncss .fs40-md {
    font-size: 40px;
    line-height: 1.2;
  }
}
@media only screen and (min-width: 1024px) {
  .ua-ncss .fs10-lg {
    font-size: 10px;
    line-height: 2.4;
  }
  .ua-ncss .fs12-lg {
    font-size: 12px;
    line-height: 2;
  }
  .ua-ncss .fs14-lg {
    font-size: 14px;
    line-height: 1.7142857143;
  }
  .ua-ncss .fs16-lg {
    font-size: 16px;
    line-height: 1.5;
  }
  .ua-ncss .fs18-lg {
    font-size: 18px;
    line-height: 1.3333333333;
  }
  .ua-ncss .fs20-lg {
    font-size: 20px;
    line-height: 1.2;
  }
  .ua-ncss .fs22-lg {
    font-size: 22px;
    line-height: 1.0909090909;
  }
  .ua-ncss .fs24-lg {
    font-size: 24px;
    line-height: 1;
  }
  .ua-ncss .fs26-lg {
    font-size: 26px;
    line-height: 1.8461538462;
  }
  .ua-ncss .fs28-lg {
    font-size: 28px;
    line-height: 1.7142857143;
  }
  .ua-ncss .fs30-lg {
    font-size: 30px;
    line-height: 1.6;
  }
  .ua-ncss .fs32-lg {
    font-size: 32px;
    line-height: 1.5;
  }
  .ua-ncss .fs34-lg {
    font-size: 34px;
    line-height: 1.4117647059;
  }
  .ua-ncss .fs36-lg {
    font-size: 36px;
    line-height: 1.3333333333;
  }
  .ua-ncss .fs38-lg {
    font-size: 38px;
    line-height: 1.2631578947;
  }
  .ua-ncss .fs40-lg {
    font-size: 40px;
    line-height: 1.2;
  }
}
@media only screen and (min-width: 1280px) {
  .ua-ncss .fs10-xl {
    font-size: 10px;
    line-height: 2.4;
  }
  .ua-ncss .fs12-xl {
    font-size: 12px;
    line-height: 2;
  }
  .ua-ncss .fs14-xl {
    font-size: 14px;
    line-height: 1.7142857143;
  }
  .ua-ncss .fs16-xl {
    font-size: 16px;
    line-height: 1.5;
  }
  .ua-ncss .fs18-xl {
    font-size: 18px;
    line-height: 1.3333333333;
  }
  .ua-ncss .fs20-xl {
    font-size: 20px;
    line-height: 1.2;
  }
  .ua-ncss .fs22-xl {
    font-size: 22px;
    line-height: 1.0909090909;
  }
  .ua-ncss .fs24-xl {
    font-size: 24px;
    line-height: 1;
  }
  .ua-ncss .fs26-xl {
    font-size: 26px;
    line-height: 1.8461538462;
  }
  .ua-ncss .fs28-xl {
    font-size: 28px;
    line-height: 1.7142857143;
  }
  .ua-ncss .fs30-xl {
    font-size: 30px;
    line-height: 1.6;
  }
  .ua-ncss .fs32-xl {
    font-size: 32px;
    line-height: 1.5;
  }
  .ua-ncss .fs34-xl {
    font-size: 34px;
    line-height: 1.4117647059;
  }
  .ua-ncss .fs36-xl {
    font-size: 36px;
    line-height: 1.3333333333;
  }
  .ua-ncss .fs38-xl {
    font-size: 38px;
    line-height: 1.2631578947;
  }
  .ua-ncss .fs40-xl {
    font-size: 40px;
    line-height: 1.2;
  }
}
@media only screen and (min-width: 1440px) {
  .ua-ncss .fs10-xxl {
    font-size: 10px;
    line-height: 2.4;
  }
  .ua-ncss .fs12-xxl {
    font-size: 12px;
    line-height: 2;
  }
  .ua-ncss .fs14-xxl {
    font-size: 14px;
    line-height: 1.7142857143;
  }
  .ua-ncss .fs16-xxl {
    font-size: 16px;
    line-height: 1.5;
  }
  .ua-ncss .fs18-xxl {
    font-size: 18px;
    line-height: 1.3333333333;
  }
  .ua-ncss .fs20-xxl {
    font-size: 20px;
    line-height: 1.2;
  }
  .ua-ncss .fs22-xxl {
    font-size: 22px;
    line-height: 1.0909090909;
  }
  .ua-ncss .fs24-xxl {
    font-size: 24px;
    line-height: 1;
  }
  .ua-ncss .fs26-xxl {
    font-size: 26px;
    line-height: 1.8461538462;
  }
  .ua-ncss .fs28-xxl {
    font-size: 28px;
    line-height: 1.7142857143;
  }
  .ua-ncss .fs30-xxl {
    font-size: 30px;
    line-height: 1.6;
  }
  .ua-ncss .fs32-xxl {
    font-size: 32px;
    line-height: 1.5;
  }
  .ua-ncss .fs34-xxl {
    font-size: 34px;
    line-height: 1.4117647059;
  }
  .ua-ncss .fs36-xxl {
    font-size: 36px;
    line-height: 1.3333333333;
  }
  .ua-ncss .fs38-xxl {
    font-size: 38px;
    line-height: 1.2631578947;
  }
  .ua-ncss .fs40-xxl {
    font-size: 40px;
    line-height: 1.2;
  }
}
.ua-ncss .lh10-sm {
  line-height: 1.4;
}

.ua-ncss .lh12-sm {
  line-height: 1.3333333333;
}

.ua-ncss .lh14-sm {
  line-height: 1.2857142857;
}

.ua-ncss .lh16-sm {
  line-height: 1.25;
}

.ua-ncss .lh18-sm {
  line-height: 1.2222222222;
}

.ua-ncss .lh20-sm {
  line-height: 1.2;
}

.ua-ncss .lh22-sm {
  line-height: 1.1818181818;
}

.ua-ncss .lh24-sm {
  line-height: 1.1666666667;
}

.ua-ncss .lh26-sm {
  line-height: 1.1538461538;
}

.ua-ncss .lh28-sm {
  line-height: 1.1428571429;
}

.ua-ncss .lh30-sm {
  line-height: 1.1333333333;
}

.ua-ncss .lh32-sm {
  line-height: 1.125;
}

.ua-ncss .lh34-sm {
  line-height: 1.1176470588;
}

.ua-ncss .lh36-sm {
  line-height: 1.1111111111;
}

.ua-ncss .lh38-sm {
  line-height: 1.1052631579;
}

.ua-ncss .lh40-sm {
  line-height: 1.1;
}

@media only screen and (min-width: 640px) {
  .ua-ncss .lh10-md {
    line-height: 1.4;
  }
  .ua-ncss .lh12-md {
    line-height: 1.3333333333;
  }
  .ua-ncss .lh14-md {
    line-height: 1.2857142857;
  }
  .ua-ncss .lh16-md {
    line-height: 1.25;
  }
  .ua-ncss .lh18-md {
    line-height: 1.2222222222;
  }
  .ua-ncss .lh20-md {
    line-height: 1.2;
  }
  .ua-ncss .lh22-md {
    line-height: 1.1818181818;
  }
  .ua-ncss .lh24-md {
    line-height: 1.1666666667;
  }
  .ua-ncss .lh26-md {
    line-height: 1.1538461538;
  }
  .ua-ncss .lh28-md {
    line-height: 1.1428571429;
  }
  .ua-ncss .lh30-md {
    line-height: 1.1333333333;
  }
  .ua-ncss .lh32-md {
    line-height: 1.125;
  }
  .ua-ncss .lh34-md {
    line-height: 1.1176470588;
  }
  .ua-ncss .lh36-md {
    line-height: 1.1111111111;
  }
  .ua-ncss .lh38-md {
    line-height: 1.1052631579;
  }
  .ua-ncss .lh40-md {
    line-height: 1.1;
  }
}
@media only screen and (min-width: 1024px) {
  .ua-ncss .lh10-lg {
    line-height: 1.4;
  }
  .ua-ncss .lh12-lg {
    line-height: 1.3333333333;
  }
  .ua-ncss .lh14-lg {
    line-height: 1.2857142857;
  }
  .ua-ncss .lh16-lg {
    line-height: 1.25;
  }
  .ua-ncss .lh18-lg {
    line-height: 1.2222222222;
  }
  .ua-ncss .lh20-lg {
    line-height: 1.2;
  }
  .ua-ncss .lh22-lg {
    line-height: 1.1818181818;
  }
  .ua-ncss .lh24-lg {
    line-height: 1.1666666667;
  }
  .ua-ncss .lh26-lg {
    line-height: 1.1538461538;
  }
  .ua-ncss .lh28-lg {
    line-height: 1.1428571429;
  }
  .ua-ncss .lh30-lg {
    line-height: 1.1333333333;
  }
  .ua-ncss .lh32-lg {
    line-height: 1.125;
  }
  .ua-ncss .lh34-lg {
    line-height: 1.1176470588;
  }
  .ua-ncss .lh36-lg {
    line-height: 1.1111111111;
  }
  .ua-ncss .lh38-lg {
    line-height: 1.1052631579;
  }
  .ua-ncss .lh40-lg {
    line-height: 1.1;
  }
}
@media only screen and (min-width: 1280px) {
  .ua-ncss .lh10-xl {
    line-height: 1.4;
  }
  .ua-ncss .lh12-xl {
    line-height: 1.3333333333;
  }
  .ua-ncss .lh14-xl {
    line-height: 1.2857142857;
  }
  .ua-ncss .lh16-xl {
    line-height: 1.25;
  }
  .ua-ncss .lh18-xl {
    line-height: 1.2222222222;
  }
  .ua-ncss .lh20-xl {
    line-height: 1.2;
  }
  .ua-ncss .lh22-xl {
    line-height: 1.1818181818;
  }
  .ua-ncss .lh24-xl {
    line-height: 1.1666666667;
  }
  .ua-ncss .lh26-xl {
    line-height: 1.1538461538;
  }
  .ua-ncss .lh28-xl {
    line-height: 1.1428571429;
  }
  .ua-ncss .lh30-xl {
    line-height: 1.1333333333;
  }
  .ua-ncss .lh32-xl {
    line-height: 1.125;
  }
  .ua-ncss .lh34-xl {
    line-height: 1.1176470588;
  }
  .ua-ncss .lh36-xl {
    line-height: 1.1111111111;
  }
  .ua-ncss .lh38-xl {
    line-height: 1.1052631579;
  }
  .ua-ncss .lh40-xl {
    line-height: 1.1;
  }
}
@media only screen and (min-width: 1440px) {
  .ua-ncss .lh10-xxl {
    line-height: 1.4;
  }
  .ua-ncss .lh12-xxl {
    line-height: 1.3333333333;
  }
  .ua-ncss .lh14-xxl {
    line-height: 1.2857142857;
  }
  .ua-ncss .lh16-xxl {
    line-height: 1.25;
  }
  .ua-ncss .lh18-xxl {
    line-height: 1.2222222222;
  }
  .ua-ncss .lh20-xxl {
    line-height: 1.2;
  }
  .ua-ncss .lh22-xxl {
    line-height: 1.1818181818;
  }
  .ua-ncss .lh24-xxl {
    line-height: 1.1666666667;
  }
  .ua-ncss .lh26-xxl {
    line-height: 1.1538461538;
  }
  .ua-ncss .lh28-xxl {
    line-height: 1.1428571429;
  }
  .ua-ncss .lh30-xxl {
    line-height: 1.1333333333;
  }
  .ua-ncss .lh32-xxl {
    line-height: 1.125;
  }
  .ua-ncss .lh34-xxl {
    line-height: 1.1176470588;
  }
  .ua-ncss .lh36-xxl {
    line-height: 1.1111111111;
  }
  .ua-ncss .lh38-xxl {
    line-height: 1.1052631579;
  }
  .ua-ncss .lh40-xxl {
    line-height: 1.1;
  }
}
.ua-ncss * {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.ua-ncss :after, .ua-ncss :before {
  -webkit-box-sizing: inherit;
  box-sizing: inherit;
}

.ua-ncss html {
  font-size: 14px;
  line-height: 1.7142857143;
  -webkit-text-size-adjust: none;
}

.ua-ncss body {
  font-size: inherit;
  line-height: inherit;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #111;
  background-color: #fff;
}

.ua-ncss a {
  color: #111;
  cursor: pointer;
  text-decoration: none;
}

.ua-ncss a:not([class*=ncss-btn]).disabled {
  color: rgba(17, 17, 17, 0.4);
  text-decoration: line-through;
}

.ua-ncss img {
  max-width: 100%;
}

.ua-ncss button, .ua-ncss input[type=button], .ua-ncss input[type=reset], .ua-ncss input[type=submit] {
  font-size: inherit;
  line-height: inherit;
  border: none;
  cursor: pointer;
  overflow: visible;
  -webkit-tap-highlight-color: transparent;
  -webkit-appearance: none;
}

.ua-ncss button::-moz-focus-inner, .ua-ncss input[type=button]::-moz-focus-inner, .ua-ncss input[type=reset]::-moz-focus-inner, .ua-ncss input[type=submit]::-moz-focus-inner {
  border: 0;
  padding: 0;
  margin-top: 0;
  margin-bottom: 0;
}

.ua-ncss .mouse-focus button, .ua-ncss .mouse-focus input[type=button], .ua-ncss .mouse-focus input[type=reset], .ua-ncss .mouse-focus input[type=submit] {
  outline: 0;
}

.ua-ncss .keyboard-focus button, .ua-ncss .keyboard-focus input[type=button], .ua-ncss .keyboard-focus input[type=reset], .ua-ncss .keyboard-focus input[type=submit] {
  -webkit-transition: none;
  -o-transition: none;
  transition: none;
}

.ua-ncss .keyboard-focus button:focus, .ua-ncss .keyboard-focus input[type=button]:focus, .ua-ncss .keyboard-focus input[type=reset]:focus, .ua-ncss .keyboard-focus input[type=submit]:focus {
  outline: Highlight solid 2px;
}

@media (-webkit-min-device-pixel-ratio: 0) {
  .ua-ncss .keyboard-focus button:focus, .ua-ncss .keyboard-focus input[type=button]:focus, .ua-ncss .keyboard-focus input[type=reset]:focus, .ua-ncss .keyboard-focus input[type=submit]:focus {
    outline-color: -webkit-focus-ring-color;
    outline-style: auto;
    outline-width: 5px;
  }
}
.ua-ncss [class*=ncss-btn] {
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  text-align: center;
  text-decoration: none;
  background: 0 0;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.ua-ncss [class*=ncss-btn].disabled, .ua-ncss [class*=ncss-btn]:disabled {
  opacity: 0.5;
  cursor: default;
}

.ua-ncss .ncss-btn-black {
  color: #fff;
  background: #111;
}

.ua-ncss .ncss-btn-black:not([disabled]):not(.disabled):hover {
  background: rgba(17, 17, 17, 0.75);
}

.ua-ncss .ncss-btn-border-black {
  color: #111;
  background: 0 0;
  -webkit-box-shadow: inset 0 1px 0 0 #111, inset -1px 0 0 0 #111, inset 0 -1px 0 0 #111, inset 1px 0 0 0 #111;
  box-shadow: inset 0 1px 0 0 #111, inset -1px 0 0 0 #111, inset 0 -1px 0 0 #111, inset 1px 0 0 0 #111;
}

.ua-ncss .ncss-btn-border-black:not([disabled]):not(.disabled):hover {
  background: rgba(109, 109, 109, 0.5);
}

.ua-ncss .ncss-btn-white {
  color: #111;
  background: #fff;
}

.ua-ncss .ncss-btn-white:not([disabled]):not(.disabled):hover {
  background: rgba(255, 255, 255, 0.75);
}

.ua-ncss .ncss-btn-border-white {
  color: #111;
  background: 0 0;
  -webkit-box-shadow: inset 0 1px 0 0 #fff, inset -1px 0 0 0 #fff, inset 0 -1px 0 0 #fff, inset 1px 0 0 0 #fff;
  box-shadow: inset 0 1px 0 0 #fff, inset -1px 0 0 0 #fff, inset 0 -1px 0 0 #fff, inset 1px 0 0 0 #fff;
}

.ua-ncss .ncss-btn-border-white:not([disabled]):not(.disabled):hover {
  background: rgba(109, 109, 109, 0.5);
}

.ua-ncss .ncss-btn-offwhite {
  color: #111;
  background: #f7f7f7;
}

.ua-ncss .ncss-btn-offwhite:not([disabled]):not(.disabled):hover {
  background: rgba(247, 247, 247, 0.75);
}

.ua-ncss .ncss-btn-border-offwhite {
  color: #111;
  background: 0 0;
  -webkit-box-shadow: inset 0 1px 0 0 #f7f7f7, inset -1px 0 0 0 #f7f7f7, inset 0 -1px 0 0 #f7f7f7, inset 1px 0 0 0 #f7f7f7;
  box-shadow: inset 0 1px 0 0 #f7f7f7, inset -1px 0 0 0 #f7f7f7, inset 0 -1px 0 0 #f7f7f7, inset 1px 0 0 0 #f7f7f7;
}

.ua-ncss .ncss-btn-border-offwhite:not([disabled]):not(.disabled):hover {
  background: rgba(109, 109, 109, 0.5);
}

.ua-ncss .ncss-btn-grey {
  color: #fff;
  background: #6d6d6d;
}

.ua-ncss .ncss-btn-grey:not([disabled]):not(.disabled):hover {
  background: rgba(109, 109, 109, 0.75);
}

.ua-ncss .ncss-btn-border-grey {
  color: #111;
  background: 0 0;
  -webkit-box-shadow: inset 0 1px 0 0 #6d6d6d, inset -1px 0 0 0 #6d6d6d, inset 0 -1px 0 0 #6d6d6d, inset 1px 0 0 0 #6d6d6d;
  box-shadow: inset 0 1px 0 0 #6d6d6d, inset -1px 0 0 0 #6d6d6d, inset 0 -1px 0 0 #6d6d6d, inset 1px 0 0 0 #6d6d6d;
}

.ua-ncss .ncss-btn-border-grey:not([disabled]):not(.disabled):hover {
  background: rgba(109, 109, 109, 0.5);
}

.ua-ncss .ncss-btn-dark-grey {
  color: #fff;
  background: #222;
}

.ua-ncss .ncss-btn-dark-grey:not([disabled]):not(.disabled):hover {
  background: rgba(34, 34, 34, 0.75);
}

.ua-ncss .ncss-btn-border-dark-grey {
  color: #111;
  background: 0 0;
  -webkit-box-shadow: inset 0 1px 0 0 #222, inset -1px 0 0 0 #222, inset 0 -1px 0 0 #222, inset 1px 0 0 0 #222;
  box-shadow: inset 0 1px 0 0 #222, inset -1px 0 0 0 #222, inset 0 -1px 0 0 #222, inset 1px 0 0 0 #222;
}

.ua-ncss .ncss-btn-border-dark-grey:not([disabled]):not(.disabled):hover {
  background: rgba(109, 109, 109, 0.5);
}

.ua-ncss .ncss-btn-light-grey {
  color: #111;
  background: #e5e5e5;
}

.ua-ncss .ncss-btn-light-grey:not([disabled]):not(.disabled):hover {
  background: rgba(229, 229, 229, 0.75);
}

.ua-ncss .ncss-btn-border-light-grey {
  color: #111;
  background: 0 0;
  -webkit-box-shadow: inset 0 1px 0 0 #e5e5e5, inset -1px 0 0 0 #e5e5e5, inset 0 -1px 0 0 #e5e5e5, inset 1px 0 0 0 #e5e5e5;
  box-shadow: inset 0 1px 0 0 #e5e5e5, inset -1px 0 0 0 #e5e5e5, inset 0 -1px 0 0 #e5e5e5, inset 1px 0 0 0 #e5e5e5;
}

.ua-ncss .ncss-btn-border-light-grey:not([disabled]):not(.disabled):hover {
  background: rgba(109, 109, 109, 0.5);
}

.ua-ncss .ncss-btn-medium-grey {
  color: #111;
  background: #ddd;
}

.ua-ncss .ncss-btn-medium-grey:not([disabled]):not(.disabled):hover {
  background: rgba(221, 221, 221, 0.75);
}

.ua-ncss .ncss-btn-border-medium-grey {
  color: #111;
  background: 0 0;
  -webkit-box-shadow: inset 0 1px 0 0 #ddd, inset -1px 0 0 0 #ddd, inset 0 -1px 0 0 #ddd, inset 1px 0 0 0 #ddd;
  box-shadow: inset 0 1px 0 0 #ddd, inset -1px 0 0 0 #ddd, inset 0 -1px 0 0 #ddd, inset 1px 0 0 0 #ddd;
}

.ua-ncss .ncss-btn-border-medium-grey:not([disabled]):not(.disabled):hover {
  background: rgba(109, 109, 109, 0.5);
}

.ua-ncss .ncss-btn-accent {
  color: #fff;
  background: #fa5400;
}

.ua-ncss .ncss-btn-accent:not([disabled]):not(.disabled):hover {
  background: rgba(250, 84, 0, 0.75);
}

.ua-ncss .ncss-btn-border-accent {
  color: #111;
  background: 0 0;
  -webkit-box-shadow: inset 0 1px 0 0 #fa5400, inset -1px 0 0 0 #fa5400, inset 0 -1px 0 0 #fa5400, inset 1px 0 0 0 #fa5400;
  box-shadow: inset 0 1px 0 0 #fa5400, inset -1px 0 0 0 #fa5400, inset 0 -1px 0 0 #fa5400, inset 1px 0 0 0 #fa5400;
}

.ua-ncss .ncss-btn-border-accent:not([disabled]):not(.disabled):hover {
  background: rgba(109, 109, 109, 0.5);
}

.ua-ncss .ncss-btn-error {
  color: #fff;
  background: #fe0000;
}

.ua-ncss .ncss-btn-error:not([disabled]):not(.disabled):hover {
  background: rgba(254, 0, 0, 0.75);
}

.ua-ncss .ncss-btn-border-error {
  color: #111;
  background: 0 0;
  -webkit-box-shadow: inset 0 1px 0 0 #fe0000, inset -1px 0 0 0 #fe0000, inset 0 -1px 0 0 #fe0000, inset 1px 0 0 0 #fe0000;
  box-shadow: inset 0 1px 0 0 #fe0000, inset -1px 0 0 0 #fe0000, inset 0 -1px 0 0 #fe0000, inset 1px 0 0 0 #fe0000;
}

.ua-ncss .ncss-btn-border-error:not([disabled]):not(.disabled):hover {
  background: rgba(109, 109, 109, 0.5);
}

.ua-ncss .ncss-btn-success {
  color: #fff;
  background: #48bd1f;
}

.ua-ncss .ncss-btn-success:not([disabled]):not(.disabled):hover {
  background: rgba(72, 189, 31, 0.75);
}

.ua-ncss .ncss-btn-border-success {
  color: #111;
  background: 0 0;
  -webkit-box-shadow: inset 0 1px 0 0 #48bd1f, inset -1px 0 0 0 #48bd1f, inset 0 -1px 0 0 #48bd1f, inset 1px 0 0 0 #48bd1f;
  box-shadow: inset 0 1px 0 0 #48bd1f, inset -1px 0 0 0 #48bd1f, inset 0 -1px 0 0 #48bd1f, inset 1px 0 0 0 #48bd1f;
}

.ua-ncss .ncss-btn-border-success:not([disabled]):not(.disabled):hover {
  background: rgba(109, 109, 109, 0.5);
}

.ua-ncss .ncss-flyout {
  display: inline-block;
  position: relative;
  z-index: 1;
}

.ua-ncss .ncss-flyout:not([disabled]):not(.disabled):hover .ncss-flyout-options {
  opacity: 1;
  visibility: visible;
  -webkit-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transform: translate(0, 0);
}

.ua-ncss .ncss-flyout.disabled, .ua-ncss .ncss-flyout:disabled {
  opacity: 0.5;
}

.ua-ncss .ncss-flyout.disabled .ncss-flyout-btn, .ua-ncss .ncss-flyout:disabled .ncss-flyout-btn {
  cursor: default;
}

.ua-ncss .ncss-flyout-btn {
  display: inline-block;
  font-size: 14px;
  line-height: 1.7142857143;
  text-decoration: none;
  cursor: pointer;
  position: relative;
  z-index: 1;
  padding: 8px 40px 8px 20px;
}

.ua-ncss .ncss-flyout-btn:after {
  font-family: nike-glyphs, sans-serif;
  content: "\\e607";
  font-size: 10px;
  position: absolute;
  top: 50%;
  right: 16px;
  -webkit-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  transform: translate(0, -50%);
}

.ua-ncss .ncss-flyout-span, .ua-ncss .ncss-flyout-span-num {
  margin-left: 4px;
  color: #707070;
  vertical-align: top;
}

.ua-ncss .ncss-flyout-span-num:before {
  content: "(";
}

.ua-ncss .ncss-flyout-span-num:after {
  content: ")";
}

.ua-ncss .ncss-flyout-options {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  left: 0;
  right: 0;
  background: #f1f1f1;
  max-height: 272px;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-box-shadow: inset -1px 0 0 0 #e5e5e5, inset 0 -1px 0 0 #e5e5e5, inset 1px 0 0 0 #e5e5e5;
  box-shadow: inset -1px 0 0 0 #e5e5e5, inset 0 -1px 0 0 #e5e5e5, inset 1px 0 0 0 #e5e5e5;
  -webkit-transform: translate(0, -20%);
  -ms-transform: translate(0, -20%);
  transform: translate(0, -20%);
  -webkit-transition: all 0.15s ease;
  -o-transition: all 0.15s ease;
  transition: all 0.15s ease;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.ua-ncss .ncss-flyout-options .ncss-option {
  display: inline-block;
  font-size: 14px;
  line-height: 1.7142857143;
  text-decoration: none;
  cursor: pointer;
  width: 100%;
  color: #111;
  background: 0 0;
  -webkit-box-shadow: inset 0 1px 0 0 #e5e5e5;
  box-shadow: inset 0 1px 0 0 #e5e5e5;
}

.ua-ncss .ncss-flyout-options .ncss-option:first-child {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.ua-ncss .ncss-flyout-options .ncss-option:hover {
  background: #dfdfdf;
  color: #111;
}

.ua-ncss .ncss-flyout-options .ncss-option.active, .ua-ncss .ncss-flyout-options .ncss-option:active {
  background: #111;
  color: #fff;
  text-decoration: none;
  -webkit-box-shadow: inset 0 1px 0 0 #111;
  box-shadow: inset 0 1px 0 0 #111;
}

.ua-ncss input, .ua-ncss textarea {
  border: 0;
  margin: 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  -webkit-appearance: none;
  -webkit-border-radius: 2px;
  border-radius: 2px;
}

.ua-ncss input:focus, .ua-ncss textarea:focus {
  outline: 0;
}

.ua-ncss input::-ms-clear, .ua-ncss textarea::-ms-clear {
  display: none;
}

.ua-ncss .ncss-form-group.inline .ncss-input-container, .ua-ncss .ncss-form-group.inline .ncss-textarea-container {
  display: table-row;
}

.ua-ncss .ncss-form-group.inline .ncss-input, .ua-ncss .ncss-form-group.inline .ncss-label, .ua-ncss .ncss-form-group.inline .ncss-textarea {
  display: table-cell;
  vertical-align: middle;
}

.ua-ncss .ncss-input-container, .ua-ncss .ncss-textarea-container {
  width: 100%;
  position: relative;
  display: inline-block;
  text-align: left;
  overflow: hidden;
}

.ua-ncss .ncss-input-container .ncss-input, .ua-ncss .ncss-textarea-container .ncss-input {
  width: 100%;
  height: inherit;
  position: relative;
  z-index: 1;
  -webkit-box-shadow: inset 0 1px 0 0 #ddd, inset -1px 0 0 0 #ddd, inset 0 -1px 0 0 #ddd, inset 1px 0 0 0 #ddd;
  box-shadow: inset 0 1px 0 0 #ddd, inset -1px 0 0 0 #ddd, inset 0 -1px 0 0 #ddd, inset 1px 0 0 0 #ddd;
  min-height: 48px;
}

@media only screen and (min-width: 1024px) {
  .ua-ncss .ncss-input-container .ncss-input, .ua-ncss .ncss-textarea-container .ncss-input {
    min-height: 40px;
  }
}
.ua-ncss .ncss-input-container .ncss-input::-webkit-input-placeholder, .ua-ncss .ncss-textarea-container .ncss-input::-webkit-input-placeholder {
  color: #6d6d6d;
}

.ua-ncss .ncss-input-container .ncss-input:-moz-placeholder, .ua-ncss .ncss-textarea-container .ncss-input:-moz-placeholder {
  color: #6d6d6d;
}

.ua-ncss .ncss-input-container .ncss-input::-moz-placeholder, .ua-ncss .ncss-textarea-container .ncss-input::-moz-placeholder {
  color: #6d6d6d;
}

.ua-ncss .ncss-input-container .ncss-input:-ms-input-placeholder, .ua-ncss .ncss-textarea-container .ncss-input:-ms-input-placeholder {
  color: #6d6d6d;
}

.ua-ncss .ncss-input-container .ncss-input:focus, .ua-ncss .ncss-textarea-container .ncss-input:focus {
  outline: 0;
  -webkit-box-shadow: inset 0 1px 0 0 #6d6d6d, inset -1px 0 0 0 #6d6d6d, inset 0 -1px 0 0 #6d6d6d, inset 1px 0 0 0 #6d6d6d;
  box-shadow: inset 0 1px 0 0 #6d6d6d, inset -1px 0 0 0 #6d6d6d, inset 0 -1px 0 0 #6d6d6d, inset 1px 0 0 0 #6d6d6d;
}

.ua-ncss .ncss-input-container .ncss-textarea, .ua-ncss .ncss-textarea-container .ncss-textarea {
  width: 100%;
  height: inherit;
  position: relative;
  z-index: 1;
  -webkit-box-shadow: inset 0 1px 0 0 #ddd, inset -1px 0 0 0 #ddd, inset 0 -1px 0 0 #ddd, inset 1px 0 0 0 #ddd;
  box-shadow: inset 0 1px 0 0 #ddd, inset -1px 0 0 0 #ddd, inset 0 -1px 0 0 #ddd, inset 1px 0 0 0 #ddd;
  min-height: 96px;
  resize: vertical;
  overflow: auto;
  display: block;
}

.ua-ncss .ncss-input-container .ncss-textarea:focus, .ua-ncss .ncss-textarea-container .ncss-textarea:focus {
  outline: 0;
  -webkit-box-shadow: inset 0 1px 0 0 #6d6d6d, inset -1px 0 0 0 #6d6d6d, inset 0 -1px 0 0 #6d6d6d, inset 1px 0 0 0 #6d6d6d;
  box-shadow: inset 0 1px 0 0 #6d6d6d, inset -1px 0 0 0 #6d6d6d, inset 0 -1px 0 0 #6d6d6d, inset 1px 0 0 0 #6d6d6d;
}

.ua-ncss .ncss-input-container .ncss-label, .ua-ncss .ncss-textarea-container .ncss-label {
  display: block;
}

.ua-ncss .ncss-input-container .ncss-error-msg, .ua-ncss .ncss-textarea-container .ncss-error-msg {
  display: none;
  color: #fe0000;
  font-size: 12px;
  line-height: 2;
}

.ua-ncss .ncss-input-container.error .ncss-input, .ua-ncss .ncss-input-container.error .ncss-textarea, .ua-ncss .ncss-textarea-container.error .ncss-input, .ua-ncss .ncss-textarea-container.error .ncss-textarea {
  -webkit-box-shadow: inset 0 1px 0 0 #fe0000, inset -1px 0 0 0 #fe0000, inset 0 -1px 0 0 #fe0000, inset 1px 0 0 0 #fe0000;
  box-shadow: inset 0 1px 0 0 #fe0000, inset -1px 0 0 0 #fe0000, inset 0 -1px 0 0 #fe0000, inset 1px 0 0 0 #fe0000;
}

.ua-ncss .ncss-input-container.error .ncss-error-msg, .ua-ncss .ncss-textarea-container.error .ncss-error-msg {
  display: block;
}

.ua-ncss input[type=radio] {
  -webkit-appearance: radio;
}

.ua-ncss input[type=checkbox] {
  -webkit-appearance: checkbox;
}

.ua-ncss .ncss-form-group.inline .ncss-checkbox-container, .ua-ncss .ncss-form-group.inline .ncss-radio-container {
  display: table-cell;
  vertical-align: middle;
}

.ua-ncss .ncss-form-group.group-up {
  border: 1px solid #e5e5e5;
  -webkit-border-radius: 2px;
  border-radius: 2px;
}

.ua-ncss .ncss-form-group.group-up .ncss-radio-container {
  border-top: 1px solid #e5e5e5;
}

.ua-ncss .ncss-form-group.group-up .ncss-radio-container:first-child {
  border: 0;
}

.ua-ncss .ncss-form-group.group-up .ncss-radio-container .ncss-label {
  color: #111;
  background: #f7f7f7;
  -webkit-transition: background 0.4s ease;
  -o-transition: background 0.4s ease;
  transition: background 0.4s ease;
}

.ua-ncss .ncss-form-group.group-up .ncss-radio-container .ncss-label:before {
  left: 16px;
  width: 16px;
  height: 16px;
}

.ua-ncss .ncss-form-group.group-up .ncss-radio-container .ncss-radio:checked + .ncss-label {
  background: #fff;
}

.ua-ncss .keyboard-focus .ncss-form-group.group-up .ncss-radio-container .ncss-radio:focus + .ncss-label {
  -webkit-box-shadow: inset 0 1px 0 0 #111, inset -1px 0 0 0 #111, inset 0 -1px 0 0 #111, inset 1px 0 0 0 #111;
  box-shadow: inset 0 1px 0 0 #111, inset -1px 0 0 0 #111, inset 0 -1px 0 0 #111, inset 1px 0 0 0 #111;
}

.ua-ncss .ncss-checkbox-container {
  position: relative;
}

.ua-ncss .ncss-checkbox-container .ncss-label {
  display: inline-block;
  vertical-align: top;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ua-ncss .ncss-checkbox-container .ncss-label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  background: #fff;
  -webkit-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  transform: translate(0, -50%);
  border: 1px solid #ddd;
  width: 16px;
  height: 16px;
}

.ua-ncss .ncss-checkbox-container .ncss-checkbox, .ua-ncss .ncss-checkbox-container .ncss-radio {
  position: absolute;
  left: -9999px;
}

.ua-ncss .ncss-checkbox-container .ncss-checkbox:disabled + .ncss-label, .ua-ncss .ncss-checkbox-container .ncss-radio:disabled + .ncss-label {
  opacity: 0.55;
  cursor: default;
}

.ua-ncss .ncss-checkbox-container.error .ncss-label:before {
  border: 1px solid #fe0000;
}

.ua-ncss .ncss-checkbox-container .ncss-label:before {
  -webkit-border-radius: 2px;
  border-radius: 2px;
}

.ua-ncss .ncss-checkbox-container .ncss-label:after {
  position: absolute;
  top: 50%;
  left: 5px;
  font-family: nike-glyphs, sans-serif;
  font-size: 8px;
  line-height: 3;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.ua-ncss .ncss-checkbox-container .ncss-checkbox:checked + .ncss-label:after {
  content: "\\e611";
}

.ua-ncss .keyboard-focus .ncss-checkbox-container .ncss-checkbox:focus + .ncss-label:before {
  outline: 0;
  -webkit-box-shadow: inset 0 1px 0 0 #111, inset -1px 0 0 0 #111, inset 0 -1px 0 0 #111, inset 1px 0 0 0 #111;
  box-shadow: inset 0 1px 0 0 #111, inset -1px 0 0 0 #111, inset 0 -1px 0 0 #111, inset 1px 0 0 0 #111;
}

.ua-ncss .ncss-radio-container {
  position: relative;
}

.ua-ncss .ncss-radio-container .ncss-label {
  display: inline-block;
  vertical-align: top;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ua-ncss .ncss-radio-container .ncss-label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  background: #fff;
  -webkit-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  transform: translate(0, -50%);
  border: 1px solid #ddd;
  width: 16px;
  height: 16px;
}

.ua-ncss .ncss-radio-container .ncss-checkbox, .ua-ncss .ncss-radio-container .ncss-radio {
  position: absolute;
  left: -9999px;
}

.ua-ncss .ncss-radio-container .ncss-checkbox:disabled + .ncss-label, .ua-ncss .ncss-radio-container .ncss-radio:disabled + .ncss-label {
  opacity: 0.55;
  cursor: default;
}

.ua-ncss .ncss-radio-container.error .ncss-label:before {
  border: 1px solid #fe0000;
}

.ua-ncss .ncss-radio-container .ncss-label:before {
  -webkit-border-radius: 25px;
  border-radius: 25px;
}

.ua-ncss .ncss-radio-container .ncss-radio:checked + .ncss-label:before {
  background: #111;
  border: 1px solid #111;
}

.ua-ncss .keyboard-focus .ncss-radio-container .ncss-radio:focus + .ncss-label:after {
  content: "";
  position: absolute;
  left: 2px;
  top: 50%;
  -webkit-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  transform: translate(0, -50%);
  border: 2px solid #fff;
  -webkit-border-radius: 25px;
  border-radius: 25px;
  width: 12px;
  height: 12px;
}

.ua-ncss .ncss-form-group.inline {
  display: table;
}

.ua-ncss .ncss-form-group.inline .ncss-select-container {
  display: table-row;
}

.ua-ncss .ncss-form-group.inline .ncss-select {
  display: table-cell;
  vertical-align: middle;
}

.ua-ncss .ncss-form-group.inline .ncss-label {
  width: 1%;
  white-space: nowrap;
}

.ua-ncss .ncss-select-container {
  width: 100%;
  position: relative;
  display: block;
  text-align: left;
  overflow: hidden;
}

.ua-ncss .ncss-select-container .ncss-select {
  width: 100%;
  min-height: 48px;
  position: relative;
  z-index: 1;
  overflow: hidden;
  background: #fff;
}

@media only screen and (min-width: 1024px) {
  .ua-ncss .ncss-select-container .ncss-select {
    min-height: 40px;
  }
}
.ua-ncss .ncss-select-container .ncss-select-menu {
  position: absolute;
  left: 0;
  top: 0;
  right: -16px;
  min-height: inherit;
  font-size: 14px;
  line-height: 1.7142857143;
  background: 0 0;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  border: 0;
  -webkit-box-shadow: inset 0 1px 0 0 #ddd, inset -1px 0 0 0 #ddd, inset 0 -1px 0 0 #ddd, inset 1px 0 0 0 #ddd;
  box-shadow: inset 0 1px 0 0 #ddd, inset -1px 0 0 0 #ddd, inset 0 -1px 0 0 #ddd, inset 1px 0 0 0 #ddd;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.ua-ncss .ncss-select-container .ncss-select-menu::-ms-expand {
  display: none;
  border: none;
}

.ua-ncss .ncss-select-container .ncss-select-menu::-ms-value {
  background: 0 0;
  color: #111;
}

.ua-ncss .ncss-select-container .ncss-select-menu:focus {
  outline: 0;
  -webkit-box-shadow: inset 0 1px 0 0 #6d6d6d, inset -1px 0 0 0 #6d6d6d, inset 0 -1px 0 0 #6d6d6d, inset 1px 0 0 0 #6d6d6d;
  box-shadow: inset 0 1px 0 0 #6d6d6d, inset -1px 0 0 0 #6d6d6d, inset 0 -1px 0 0 #6d6d6d, inset 1px 0 0 0 #6d6d6d;
}

.ua-ncss .ncss-select-container .ncss-label {
  display: block;
}

.ua-ncss .ncss-select-container .ncss-error-msg {
  display: none;
  color: #fe0000;
  font-size: 12px;
  line-height: 2;
}

.ua-ncss .ncss-select-container.error .ncss-select-menu {
  -webkit-box-shadow: inset 0 1px 0 0 #fe0000, inset -1px 0 0 0 #fe0000, inset 0 -1px 0 0 #fe0000, inset 1px 0 0 0 #fe0000;
  box-shadow: inset 0 1px 0 0 #fe0000, inset -1px 0 0 0 #fe0000, inset 0 -1px 0 0 #fe0000, inset 1px 0 0 0 #fe0000;
}

.ua-ncss .ncss-select-container.error .ncss-error-msg {
  display: block;
}

.ua-ncss .ncss-toggle-btn {
  font-size: 0;
  display: inline-block;
  background: #fff;
  white-space: nowrap;
}

.ua-ncss .ncss-toggle-btn-item {
  display: inline-block;
  font-size: 14px;
  line-height: 1.7142857143;
}

.ua-ncss .ncss-toggle-btn-item .ncss-label {
  display: inline-block;
  vertical-align: top;
  text-decoration: none;
  cursor: pointer;
  overflow: hidden;
  -webkit-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  background: rgba(17, 17, 17, 0);
}

.ua-ncss .ncss-toggle-btn-item .ncss-label:focus, .ua-ncss .ncss-toggle-btn-item .ncss-label:hover {
  background: rgba(109, 109, 109, 0.5);
}

.ua-ncss .ncss-toggle-btn-item .ncss-radio {
  position: absolute;
  left: -9999px;
}

.ua-ncss .ncss-toggle-btn-item .ncss-radio:checked + .ncss-label {
  color: #fff;
  background: #111;
}

.ua-ncss .ncss-toggle-line {
  font-size: 0;
  display: inline-block;
  white-space: nowrap;
}

.ua-ncss .ncss-toggle-line-item {
  display: inline-block;
  vertical-align: top;
  font-size: 14px;
  line-height: 1.7142857143;
}

.ua-ncss .ncss-toggle-line-item .ncss-label {
  display: inline-block;
  vertical-align: top;
  text-decoration: none;
  cursor: pointer;
  overflow: hidden;
  -webkit-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.ua-ncss .ncss-toggle-line-item .ncss-label:after {
  content: "";
  display: block;
  position: relative;
  -webkit-box-shadow: inset 0 -2px 0 0 #000;
  box-shadow: inset 0 -2px 0 0 #000;
  height: 2px;
  opacity: 0;
  margin-bottom: -2px;
  -webkit-transition: opacity 0.2s ease;
  -o-transition: opacity 0.2s ease;
  transition: opacity 0.2s ease;
}

.ua-ncss .ncss-toggle-line-item .ncss-radio {
  position: absolute;
  left: -9999px;
}

.ua-ncss .ncss-toggle-line-item .ncss-radio:checked + label:after {
  opacity: 1;
}

.ua-ncss .ncss-container {
  width: 100%;
  padding-left: 8px;
  padding-right: 8px;
}

.ua-ncss .ncss-container.fixed {
  margin-left: auto;
  margin-right: auto;
  width: 1440px;
}

.ua-ncss .ncss-container.fixed-fluid {
  margin-left: auto;
  margin-right: auto;
  max-width: 1440px;
}

.ua-ncss .ncss-row {
  font-size: 0;
  margin-left: -8px;
  margin-right: -8px;
}

.ua-ncss .ncss-row:after, .ua-ncss .ncss-row:before {
  content: "";
  display: table;
}

.ua-ncss .ncss-row:after {
  clear: both;
}

.ua-ncss [class*=ncss-col-] {
  position: relative;
  min-height: 1px;
  display: none;
  font-size: 14px;
  line-height: 1.7142857143;
  padding-left: 8px;
  padding-right: 8px;
}

.ua-ncss [class*=ncss-col-].full {
  padding-left: 0;
  padding-right: 0;
}

.ua-ncss [class*=ncss-col-].full > .ncss-row {
  margin-right: 0;
  margin-left: 0;
}

.ua-ncss .ncss-col-sm-1 {
  width: 8.3333333333%;
  display: inline-block;
}

.ua-ncss .ncss-col-sm-offset-1 {
  margin-left: 8.3333333333%;
}

.ua-ncss .ncss-col-sm-push-1 {
  left: 8.3333333333%;
}

.ua-ncss .ncss-col-sm-pull-1 {
  right: 8.3333333333%;
}

.ua-ncss .ncss-col-sm-2 {
  width: 16.6666666667%;
  display: inline-block;
}

.ua-ncss .ncss-col-sm-offset-2 {
  margin-left: 16.6666666667%;
}

.ua-ncss .ncss-col-sm-push-2 {
  left: 16.6666666667%;
}

.ua-ncss .ncss-col-sm-pull-2 {
  right: 16.6666666667%;
}

.ua-ncss .ncss-col-sm-3 {
  width: 25%;
  display: inline-block;
}

.ua-ncss .ncss-col-sm-offset-3 {
  margin-left: 25%;
}

.ua-ncss .ncss-col-sm-push-3 {
  left: 25%;
}

.ua-ncss .ncss-col-sm-pull-3 {
  right: 25%;
}

.ua-ncss .ncss-col-sm-4 {
  width: 33.3333333333%;
  display: inline-block;
}

.ua-ncss .ncss-col-sm-offset-4 {
  margin-left: 33.3333333333%;
}

.ua-ncss .ncss-col-sm-push-4 {
  left: 33.3333333333%;
}

.ua-ncss .ncss-col-sm-pull-4 {
  right: 33.3333333333%;
}

.ua-ncss .ncss-col-sm-5 {
  width: 41.6666666667%;
  display: inline-block;
}

.ua-ncss .ncss-col-sm-offset-5 {
  margin-left: 41.6666666667%;
}

.ua-ncss .ncss-col-sm-push-5 {
  left: 41.6666666667%;
}

.ua-ncss .ncss-col-sm-pull-5 {
  right: 41.6666666667%;
}

.ua-ncss .ncss-col-sm-6 {
  width: 50%;
  display: inline-block;
}

.ua-ncss .ncss-col-sm-offset-6 {
  margin-left: 50%;
}

.ua-ncss .ncss-col-sm-push-6 {
  left: 50%;
}

.ua-ncss .ncss-col-sm-pull-6 {
  right: 50%;
}

.ua-ncss .ncss-col-sm-7 {
  width: 58.3333333333%;
  display: inline-block;
}

.ua-ncss .ncss-col-sm-offset-7 {
  margin-left: 58.3333333333%;
}

.ua-ncss .ncss-col-sm-push-7 {
  left: 58.3333333333%;
}

.ua-ncss .ncss-col-sm-pull-7 {
  right: 58.3333333333%;
}

.ua-ncss .ncss-col-sm-8 {
  width: 66.6666666667%;
  display: inline-block;
}

.ua-ncss .ncss-col-sm-offset-8 {
  margin-left: 66.6666666667%;
}

.ua-ncss .ncss-col-sm-push-8 {
  left: 66.6666666667%;
}

.ua-ncss .ncss-col-sm-pull-8 {
  right: 66.6666666667%;
}

.ua-ncss .ncss-col-sm-9 {
  width: 75%;
  display: inline-block;
}

.ua-ncss .ncss-col-sm-offset-9 {
  margin-left: 75%;
}

.ua-ncss .ncss-col-sm-push-9 {
  left: 75%;
}

.ua-ncss .ncss-col-sm-pull-9 {
  right: 75%;
}

.ua-ncss .ncss-col-sm-10 {
  width: 83.3333333333%;
  display: inline-block;
}

.ua-ncss .ncss-col-sm-offset-10 {
  margin-left: 83.3333333333%;
}

.ua-ncss .ncss-col-sm-push-10 {
  left: 83.3333333333%;
}

.ua-ncss .ncss-col-sm-pull-10 {
  right: 83.3333333333%;
}

.ua-ncss .ncss-col-sm-11 {
  width: 91.6666666667%;
  display: inline-block;
}

.ua-ncss .ncss-col-sm-offset-11 {
  margin-left: 91.6666666667%;
}

.ua-ncss .ncss-col-sm-push-11 {
  left: 91.6666666667%;
}

.ua-ncss .ncss-col-sm-pull-11 {
  right: 91.6666666667%;
}

.ua-ncss .ncss-col-sm-12 {
  width: 100%;
  display: inline-block;
}

.ua-ncss .ncss-col-sm-offset-12 {
  margin-left: 100%;
}

.ua-ncss .ncss-col-sm-push-12 {
  left: 100%;
}

.ua-ncss .ncss-col-sm-pull-12 {
  right: 100%;
}

@media only screen and (min-width: 640px) {
  .ua-ncss .ncss-col-md-1 {
    width: 8.3333333333%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-md-offset-1 {
    margin-left: 8.3333333333%;
  }
  .ua-ncss .ncss-col-md-push-1 {
    left: 8.3333333333%;
  }
  .ua-ncss .ncss-col-md-pull-1 {
    right: 8.3333333333%;
  }
  .ua-ncss .ncss-col-md-2 {
    width: 16.6666666667%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-md-offset-2 {
    margin-left: 16.6666666667%;
  }
  .ua-ncss .ncss-col-md-push-2 {
    left: 16.6666666667%;
  }
  .ua-ncss .ncss-col-md-pull-2 {
    right: 16.6666666667%;
  }
  .ua-ncss .ncss-col-md-3 {
    width: 25%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-md-offset-3 {
    margin-left: 25%;
  }
  .ua-ncss .ncss-col-md-push-3 {
    left: 25%;
  }
  .ua-ncss .ncss-col-md-pull-3 {
    right: 25%;
  }
  .ua-ncss .ncss-col-md-4 {
    width: 33.3333333333%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-md-offset-4 {
    margin-left: 33.3333333333%;
  }
  .ua-ncss .ncss-col-md-push-4 {
    left: 33.3333333333%;
  }
  .ua-ncss .ncss-col-md-pull-4 {
    right: 33.3333333333%;
  }
  .ua-ncss .ncss-col-md-5 {
    width: 41.6666666667%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-md-offset-5 {
    margin-left: 41.6666666667%;
  }
  .ua-ncss .ncss-col-md-push-5 {
    left: 41.6666666667%;
  }
  .ua-ncss .ncss-col-md-pull-5 {
    right: 41.6666666667%;
  }
  .ua-ncss .ncss-col-md-6 {
    width: 50%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-md-offset-6 {
    margin-left: 50%;
  }
  .ua-ncss .ncss-col-md-push-6 {
    left: 50%;
  }
  .ua-ncss .ncss-col-md-pull-6 {
    right: 50%;
  }
  .ua-ncss .ncss-col-md-7 {
    width: 58.3333333333%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-md-offset-7 {
    margin-left: 58.3333333333%;
  }
  .ua-ncss .ncss-col-md-push-7 {
    left: 58.3333333333%;
  }
  .ua-ncss .ncss-col-md-pull-7 {
    right: 58.3333333333%;
  }
  .ua-ncss .ncss-col-md-8 {
    width: 66.6666666667%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-md-offset-8 {
    margin-left: 66.6666666667%;
  }
  .ua-ncss .ncss-col-md-push-8 {
    left: 66.6666666667%;
  }
  .ua-ncss .ncss-col-md-pull-8 {
    right: 66.6666666667%;
  }
  .ua-ncss .ncss-col-md-9 {
    width: 75%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-md-offset-9 {
    margin-left: 75%;
  }
  .ua-ncss .ncss-col-md-push-9 {
    left: 75%;
  }
  .ua-ncss .ncss-col-md-pull-9 {
    right: 75%;
  }
  .ua-ncss .ncss-col-md-10 {
    width: 83.3333333333%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-md-offset-10 {
    margin-left: 83.3333333333%;
  }
  .ua-ncss .ncss-col-md-push-10 {
    left: 83.3333333333%;
  }
  .ua-ncss .ncss-col-md-pull-10 {
    right: 83.3333333333%;
  }
  .ua-ncss .ncss-col-md-11 {
    width: 91.6666666667%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-md-offset-11 {
    margin-left: 91.6666666667%;
  }
  .ua-ncss .ncss-col-md-push-11 {
    left: 91.6666666667%;
  }
  .ua-ncss .ncss-col-md-pull-11 {
    right: 91.6666666667%;
  }
  .ua-ncss .ncss-col-md-12 {
    width: 100%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-md-offset-12 {
    margin-left: 100%;
  }
  .ua-ncss .ncss-col-md-push-12 {
    left: 100%;
  }
  .ua-ncss .ncss-col-md-pull-12 {
    right: 100%;
  }
}
@media only screen and (min-width: 1024px) {
  .ua-ncss .ncss-col-lg-1 {
    width: 8.3333333333%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-lg-offset-1 {
    margin-left: 8.3333333333%;
  }
  .ua-ncss .ncss-col-lg-push-1 {
    left: 8.3333333333%;
  }
  .ua-ncss .ncss-col-lg-pull-1 {
    right: 8.3333333333%;
  }
  .ua-ncss .ncss-col-lg-2 {
    width: 16.6666666667%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-lg-offset-2 {
    margin-left: 16.6666666667%;
  }
  .ua-ncss .ncss-col-lg-push-2 {
    left: 16.6666666667%;
  }
  .ua-ncss .ncss-col-lg-pull-2 {
    right: 16.6666666667%;
  }
  .ua-ncss .ncss-col-lg-3 {
    width: 25%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-lg-offset-3 {
    margin-left: 25%;
  }
  .ua-ncss .ncss-col-lg-push-3 {
    left: 25%;
  }
  .ua-ncss .ncss-col-lg-pull-3 {
    right: 25%;
  }
  .ua-ncss .ncss-col-lg-4 {
    width: 33.3333333333%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-lg-offset-4 {
    margin-left: 33.3333333333%;
  }
  .ua-ncss .ncss-col-lg-push-4 {
    left: 33.3333333333%;
  }
  .ua-ncss .ncss-col-lg-pull-4 {
    right: 33.3333333333%;
  }
  .ua-ncss .ncss-col-lg-5 {
    width: 41.6666666667%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-lg-offset-5 {
    margin-left: 41.6666666667%;
  }
  .ua-ncss .ncss-col-lg-push-5 {
    left: 41.6666666667%;
  }
  .ua-ncss .ncss-col-lg-pull-5 {
    right: 41.6666666667%;
  }
  .ua-ncss .ncss-col-lg-6 {
    width: 50%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-lg-offset-6 {
    margin-left: 50%;
  }
  .ua-ncss .ncss-col-lg-push-6 {
    left: 50%;
  }
  .ua-ncss .ncss-col-lg-pull-6 {
    right: 50%;
  }
  .ua-ncss .ncss-col-lg-7 {
    width: 58.3333333333%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-lg-offset-7 {
    margin-left: 58.3333333333%;
  }
  .ua-ncss .ncss-col-lg-push-7 {
    left: 58.3333333333%;
  }
  .ua-ncss .ncss-col-lg-pull-7 {
    right: 58.3333333333%;
  }
  .ua-ncss .ncss-col-lg-8 {
    width: 66.6666666667%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-lg-offset-8 {
    margin-left: 66.6666666667%;
  }
  .ua-ncss .ncss-col-lg-push-8 {
    left: 66.6666666667%;
  }
  .ua-ncss .ncss-col-lg-pull-8 {
    right: 66.6666666667%;
  }
  .ua-ncss .ncss-col-lg-9 {
    width: 75%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-lg-offset-9 {
    margin-left: 75%;
  }
  .ua-ncss .ncss-col-lg-push-9 {
    left: 75%;
  }
  .ua-ncss .ncss-col-lg-pull-9 {
    right: 75%;
  }
  .ua-ncss .ncss-col-lg-10 {
    width: 83.3333333333%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-lg-offset-10 {
    margin-left: 83.3333333333%;
  }
  .ua-ncss .ncss-col-lg-push-10 {
    left: 83.3333333333%;
  }
  .ua-ncss .ncss-col-lg-pull-10 {
    right: 83.3333333333%;
  }
  .ua-ncss .ncss-col-lg-11 {
    width: 91.6666666667%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-lg-offset-11 {
    margin-left: 91.6666666667%;
  }
  .ua-ncss .ncss-col-lg-push-11 {
    left: 91.6666666667%;
  }
  .ua-ncss .ncss-col-lg-pull-11 {
    right: 91.6666666667%;
  }
  .ua-ncss .ncss-col-lg-12 {
    width: 100%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-lg-offset-12 {
    margin-left: 100%;
  }
  .ua-ncss .ncss-col-lg-push-12 {
    left: 100%;
  }
  .ua-ncss .ncss-col-lg-pull-12 {
    right: 100%;
  }
}
@media only screen and (min-width: 1280px) {
  .ua-ncss .ncss-col-xl-1 {
    width: 8.3333333333%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xl-offset-1 {
    margin-left: 8.3333333333%;
  }
  .ua-ncss .ncss-col-xl-push-1 {
    left: 8.3333333333%;
  }
  .ua-ncss .ncss-col-xl-pull-1 {
    right: 8.3333333333%;
  }
  .ua-ncss .ncss-col-xl-2 {
    width: 16.6666666667%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xl-offset-2 {
    margin-left: 16.6666666667%;
  }
  .ua-ncss .ncss-col-xl-push-2 {
    left: 16.6666666667%;
  }
  .ua-ncss .ncss-col-xl-pull-2 {
    right: 16.6666666667%;
  }
  .ua-ncss .ncss-col-xl-3 {
    width: 25%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xl-offset-3 {
    margin-left: 25%;
  }
  .ua-ncss .ncss-col-xl-push-3 {
    left: 25%;
  }
  .ua-ncss .ncss-col-xl-pull-3 {
    right: 25%;
  }
  .ua-ncss .ncss-col-xl-4 {
    width: 33.3333333333%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xl-offset-4 {
    margin-left: 33.3333333333%;
  }
  .ua-ncss .ncss-col-xl-push-4 {
    left: 33.3333333333%;
  }
  .ua-ncss .ncss-col-xl-pull-4 {
    right: 33.3333333333%;
  }
  .ua-ncss .ncss-col-xl-5 {
    width: 41.6666666667%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xl-offset-5 {
    margin-left: 41.6666666667%;
  }
  .ua-ncss .ncss-col-xl-push-5 {
    left: 41.6666666667%;
  }
  .ua-ncss .ncss-col-xl-pull-5 {
    right: 41.6666666667%;
  }
  .ua-ncss .ncss-col-xl-6 {
    width: 50%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xl-offset-6 {
    margin-left: 50%;
  }
  .ua-ncss .ncss-col-xl-push-6 {
    left: 50%;
  }
  .ua-ncss .ncss-col-xl-pull-6 {
    right: 50%;
  }
  .ua-ncss .ncss-col-xl-7 {
    width: 58.3333333333%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xl-offset-7 {
    margin-left: 58.3333333333%;
  }
  .ua-ncss .ncss-col-xl-push-7 {
    left: 58.3333333333%;
  }
  .ua-ncss .ncss-col-xl-pull-7 {
    right: 58.3333333333%;
  }
  .ua-ncss .ncss-col-xl-8 {
    width: 66.6666666667%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xl-offset-8 {
    margin-left: 66.6666666667%;
  }
  .ua-ncss .ncss-col-xl-push-8 {
    left: 66.6666666667%;
  }
  .ua-ncss .ncss-col-xl-pull-8 {
    right: 66.6666666667%;
  }
  .ua-ncss .ncss-col-xl-9 {
    width: 75%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xl-offset-9 {
    margin-left: 75%;
  }
  .ua-ncss .ncss-col-xl-push-9 {
    left: 75%;
  }
  .ua-ncss .ncss-col-xl-pull-9 {
    right: 75%;
  }
  .ua-ncss .ncss-col-xl-10 {
    width: 83.3333333333%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xl-offset-10 {
    margin-left: 83.3333333333%;
  }
  .ua-ncss .ncss-col-xl-push-10 {
    left: 83.3333333333%;
  }
  .ua-ncss .ncss-col-xl-pull-10 {
    right: 83.3333333333%;
  }
  .ua-ncss .ncss-col-xl-11 {
    width: 91.6666666667%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xl-offset-11 {
    margin-left: 91.6666666667%;
  }
  .ua-ncss .ncss-col-xl-push-11 {
    left: 91.6666666667%;
  }
  .ua-ncss .ncss-col-xl-pull-11 {
    right: 91.6666666667%;
  }
  .ua-ncss .ncss-col-xl-12 {
    width: 100%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xl-offset-12 {
    margin-left: 100%;
  }
  .ua-ncss .ncss-col-xl-push-12 {
    left: 100%;
  }
  .ua-ncss .ncss-col-xl-pull-12 {
    right: 100%;
  }
}
@media only screen and (min-width: 1440px) {
  .ua-ncss .ncss-col-xxl-1 {
    width: 8.3333333333%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xxl-offset-1 {
    margin-left: 8.3333333333%;
  }
  .ua-ncss .ncss-col-xxl-push-1 {
    left: 8.3333333333%;
  }
  .ua-ncss .ncss-col-xxl-pull-1 {
    right: 8.3333333333%;
  }
  .ua-ncss .ncss-col-xxl-2 {
    width: 16.6666666667%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xxl-offset-2 {
    margin-left: 16.6666666667%;
  }
  .ua-ncss .ncss-col-xxl-push-2 {
    left: 16.6666666667%;
  }
  .ua-ncss .ncss-col-xxl-pull-2 {
    right: 16.6666666667%;
  }
  .ua-ncss .ncss-col-xxl-3 {
    width: 25%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xxl-offset-3 {
    margin-left: 25%;
  }
  .ua-ncss .ncss-col-xxl-push-3 {
    left: 25%;
  }
  .ua-ncss .ncss-col-xxl-pull-3 {
    right: 25%;
  }
  .ua-ncss .ncss-col-xxl-4 {
    width: 33.3333333333%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xxl-offset-4 {
    margin-left: 33.3333333333%;
  }
  .ua-ncss .ncss-col-xxl-push-4 {
    left: 33.3333333333%;
  }
  .ua-ncss .ncss-col-xxl-pull-4 {
    right: 33.3333333333%;
  }
  .ua-ncss .ncss-col-xxl-5 {
    width: 41.6666666667%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xxl-offset-5 {
    margin-left: 41.6666666667%;
  }
  .ua-ncss .ncss-col-xxl-push-5 {
    left: 41.6666666667%;
  }
  .ua-ncss .ncss-col-xxl-pull-5 {
    right: 41.6666666667%;
  }
  .ua-ncss .ncss-col-xxl-6 {
    width: 50%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xxl-offset-6 {
    margin-left: 50%;
  }
  .ua-ncss .ncss-col-xxl-push-6 {
    left: 50%;
  }
  .ua-ncss .ncss-col-xxl-pull-6 {
    right: 50%;
  }
  .ua-ncss .ncss-col-xxl-7 {
    width: 58.3333333333%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xxl-offset-7 {
    margin-left: 58.3333333333%;
  }
  .ua-ncss .ncss-col-xxl-push-7 {
    left: 58.3333333333%;
  }
  .ua-ncss .ncss-col-xxl-pull-7 {
    right: 58.3333333333%;
  }
  .ua-ncss .ncss-col-xxl-8 {
    width: 66.6666666667%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xxl-offset-8 {
    margin-left: 66.6666666667%;
  }
  .ua-ncss .ncss-col-xxl-push-8 {
    left: 66.6666666667%;
  }
  .ua-ncss .ncss-col-xxl-pull-8 {
    right: 66.6666666667%;
  }
  .ua-ncss .ncss-col-xxl-9 {
    width: 75%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xxl-offset-9 {
    margin-left: 75%;
  }
  .ua-ncss .ncss-col-xxl-push-9 {
    left: 75%;
  }
  .ua-ncss .ncss-col-xxl-pull-9 {
    right: 75%;
  }
  .ua-ncss .ncss-col-xxl-10 {
    width: 83.3333333333%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xxl-offset-10 {
    margin-left: 83.3333333333%;
  }
  .ua-ncss .ncss-col-xxl-push-10 {
    left: 83.3333333333%;
  }
  .ua-ncss .ncss-col-xxl-pull-10 {
    right: 83.3333333333%;
  }
  .ua-ncss .ncss-col-xxl-11 {
    width: 91.6666666667%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xxl-offset-11 {
    margin-left: 91.6666666667%;
  }
  .ua-ncss .ncss-col-xxl-push-11 {
    left: 91.6666666667%;
  }
  .ua-ncss .ncss-col-xxl-pull-11 {
    right: 91.6666666667%;
  }
  .ua-ncss .ncss-col-xxl-12 {
    width: 100%;
    display: inline-block;
  }
  .ua-ncss .ncss-col-xxl-offset-12 {
    margin-left: 100%;
  }
  .ua-ncss .ncss-col-xxl-push-12 {
    left: 100%;
  }
  .ua-ncss .ncss-col-xxl-pull-12 {
    right: 100%;
  }
}
.ua-ncss .ncss-list-ul .ncss-li {
  list-style-type: disc;
  margin-left: 16px;
}

.ua-ncss .ncss-list-ol .ncss-li {
  list-style: decimal inside;
}

.ua-ncss .d-sm-b {
  display: block;
}

.ua-ncss .d-sm-ib {
  display: inline-block;
}

.ua-ncss .d-sm-t {
  display: table;
}

.ua-ncss .d-sm-tr {
  display: table-row;
}

.ua-ncss .d-sm-tc {
  display: table-cell;
}

.ua-ncss .d-sm-h {
  display: none;
}

@media only screen and (min-width: 640px) {
  .ua-ncss .d-md-b {
    display: block;
  }
  .ua-ncss .d-md-ib {
    display: inline-block;
  }
  .ua-ncss .d-md-t {
    display: table;
  }
  .ua-ncss .d-md-tr {
    display: table-row;
  }
  .ua-ncss .d-md-tc {
    display: table-cell;
  }
  .ua-ncss .d-md-h {
    display: none;
  }
}
@media only screen and (min-width: 1024px) {
  .ua-ncss .d-lg-b {
    display: block;
  }
  .ua-ncss .d-lg-ib {
    display: inline-block;
  }
  .ua-ncss .d-lg-t {
    display: table;
  }
  .ua-ncss .d-lg-tr {
    display: table-row;
  }
  .ua-ncss .d-lg-tc {
    display: table-cell;
  }
  .ua-ncss .d-lg-h {
    display: none;
  }
}
@media only screen and (min-width: 1280px) {
  .ua-ncss .d-xl-b {
    display: block;
  }
  .ua-ncss .d-xl-ib {
    display: inline-block;
  }
  .ua-ncss .d-xl-t {
    display: table;
  }
  .ua-ncss .d-xl-tr {
    display: table-row;
  }
  .ua-ncss .d-xl-tc {
    display: table-cell;
  }
  .ua-ncss .d-xl-h {
    display: none;
  }
}
@media only screen and (min-width: 1440px) {
  .ua-ncss .d-xxl-b {
    display: block;
  }
  .ua-ncss .d-xxl-ib {
    display: inline-block;
  }
  .ua-ncss .d-xxl-t {
    display: table;
  }
  .ua-ncss .d-xxl-tr {
    display: table-row;
  }
  .ua-ncss .d-xxl-tc {
    display: table-cell;
  }
  .ua-ncss .d-xxl-h {
    display: none;
  }
}
.ua-ncss .fl-sm-r {
  float: right;
}

.ua-ncss .fl-sm-l {
  float: left;
}

@media only screen and (min-width: 640px) {
  .ua-ncss .fl-md-r {
    float: right;
  }
  .ua-ncss .fl-md-l {
    float: left;
  }
}
@media only screen and (min-width: 1024px) {
  .ua-ncss .fl-lg-r {
    float: right;
  }
  .ua-ncss .fl-lg-l {
    float: left;
  }
}
@media only screen and (min-width: 1280px) {
  .ua-ncss .fl-xl-r {
    float: right;
  }
  .ua-ncss .fl-xl-l {
    float: left;
  }
}
@media only screen and (min-width: 1440px) {
  .ua-ncss .fl-xxl-r {
    float: right;
  }
  .ua-ncss .fl-xxl-l {
    float: left;
  }
}
.ua-ncss .mt-0-sm, .ua-ncss .mt0-sm {
  margin-top: 0;
}

.ua-ncss .mr0-sm {
  margin-right: 0;
}

.ua-ncss .mb-0-sm, .ua-ncss .mb0-sm {
  margin-bottom: 0;
}

.ua-ncss .ml0-sm {
  margin-left: 0;
}

.ua-ncss .m0-sm {
  margin: 0;
}

.ua-ncss .mt1-sm {
  margin-top: 4px;
}

.ua-ncss .mt-1-sm {
  margin-top: -4px;
}

.ua-ncss .mr1-sm {
  margin-right: 4px;
}

.ua-ncss .mb1-sm {
  margin-bottom: 4px;
}

.ua-ncss .mb-1-sm {
  margin-bottom: -4px;
}

.ua-ncss .ml1-sm {
  margin-left: 4px;
}

.ua-ncss .m1-sm {
  margin: 4px;
}

.ua-ncss .mt2-sm {
  margin-top: 8px;
}

.ua-ncss .mt-2-sm {
  margin-top: -8px;
}

.ua-ncss .mr2-sm {
  margin-right: 8px;
}

.ua-ncss .mb2-sm {
  margin-bottom: 8px;
}

.ua-ncss .mb-2-sm {
  margin-bottom: -8px;
}

.ua-ncss .ml2-sm {
  margin-left: 8px;
}

.ua-ncss .m2-sm {
  margin: 8px;
}

.ua-ncss .mt3-sm {
  margin-top: 12px;
}

.ua-ncss .mt-3-sm {
  margin-top: -12px;
}

.ua-ncss .mr3-sm {
  margin-right: 12px;
}

.ua-ncss .mb3-sm {
  margin-bottom: 12px;
}

.ua-ncss .mb-3-sm {
  margin-bottom: -12px;
}

.ua-ncss .ml3-sm {
  margin-left: 12px;
}

.ua-ncss .m3-sm {
  margin: 12px;
}

.ua-ncss .mt4-sm {
  margin-top: 16px;
}

.ua-ncss .mt-4-sm {
  margin-top: -16px;
}

.ua-ncss .mr4-sm {
  margin-right: 16px;
}

.ua-ncss .mb4-sm {
  margin-bottom: 16px;
}

.ua-ncss .mb-4-sm {
  margin-bottom: -16px;
}

.ua-ncss .ml4-sm {
  margin-left: 16px;
}

.ua-ncss .m4-sm {
  margin: 16px;
}

.ua-ncss .mt5-sm {
  margin-top: 20px;
}

.ua-ncss .mt-5-sm {
  margin-top: -20px;
}

.ua-ncss .mr5-sm {
  margin-right: 20px;
}

.ua-ncss .mb5-sm {
  margin-bottom: 20px;
}

.ua-ncss .mb-5-sm {
  margin-bottom: -20px;
}

.ua-ncss .ml5-sm {
  margin-left: 20px;
}

.ua-ncss .m5-sm {
  margin: 20px;
}

.ua-ncss .mt6-sm {
  margin-top: 24px;
}

.ua-ncss .mt-6-sm {
  margin-top: -24px;
}

.ua-ncss .mr6-sm {
  margin-right: 24px;
}

.ua-ncss .mb6-sm {
  margin-bottom: 24px;
}

.ua-ncss .mb-6-sm {
  margin-bottom: -24px;
}

.ua-ncss .ml6-sm {
  margin-left: 24px;
}

.ua-ncss .m6-sm {
  margin: 24px;
}

.ua-ncss .mt7-sm {
  margin-top: 28px;
}

.ua-ncss .mt-7-sm {
  margin-top: -28px;
}

.ua-ncss .mr7-sm {
  margin-right: 28px;
}

.ua-ncss .mb7-sm {
  margin-bottom: 28px;
}

.ua-ncss .mb-7-sm {
  margin-bottom: -28px;
}

.ua-ncss .ml7-sm {
  margin-left: 28px;
}

.ua-ncss .m7-sm {
  margin: 28px;
}

.ua-ncss .mt8-sm {
  margin-top: 32px;
}

.ua-ncss .mt-8-sm {
  margin-top: -32px;
}

.ua-ncss .mr8-sm {
  margin-right: 32px;
}

.ua-ncss .mb8-sm {
  margin-bottom: 32px;
}

.ua-ncss .mb-8-sm {
  margin-bottom: -32px;
}

.ua-ncss .ml8-sm {
  margin-left: 32px;
}

.ua-ncss .m8-sm {
  margin: 32px;
}

.ua-ncss .mt9-sm {
  margin-top: 36px;
}

.ua-ncss .mt-9-sm {
  margin-top: -36px;
}

.ua-ncss .mr9-sm {
  margin-right: 36px;
}

.ua-ncss .mb9-sm {
  margin-bottom: 36px;
}

.ua-ncss .mb-9-sm {
  margin-bottom: -36px;
}

.ua-ncss .ml9-sm {
  margin-left: 36px;
}

.ua-ncss .m9-sm {
  margin: 36px;
}

.ua-ncss .mt10-sm {
  margin-top: 40px;
}

.ua-ncss .mt-10-sm {
  margin-top: -40px;
}

.ua-ncss .mr10-sm {
  margin-right: 40px;
}

.ua-ncss .mb10-sm {
  margin-bottom: 40px;
}

.ua-ncss .mb-10-sm {
  margin-bottom: -40px;
}

.ua-ncss .ml10-sm {
  margin-left: 40px;
}

.ua-ncss .m10-sm {
  margin: 40px;
}

.ua-ncss .mt11-sm {
  margin-top: 44px;
}

.ua-ncss .mt-11-sm {
  margin-top: -44px;
}

.ua-ncss .mr11-sm {
  margin-right: 44px;
}

.ua-ncss .mb11-sm {
  margin-bottom: 44px;
}

.ua-ncss .mb-11-sm {
  margin-bottom: -44px;
}

.ua-ncss .ml11-sm {
  margin-left: 44px;
}

.ua-ncss .m11-sm {
  margin: 44px;
}

.ua-ncss .mt12-sm {
  margin-top: 48px;
}

.ua-ncss .mt-12-sm {
  margin-top: -48px;
}

.ua-ncss .mr12-sm {
  margin-right: 48px;
}

.ua-ncss .mb12-sm {
  margin-bottom: 48px;
}

.ua-ncss .mb-12-sm {
  margin-bottom: -48px;
}

.ua-ncss .ml12-sm {
  margin-left: 48px;
}

.ua-ncss .m12-sm {
  margin: 48px;
}

.ua-ncss .mauto-sm {
  margin-left: auto;
  margin-right: auto;
}

@media only screen and (min-width: 640px) {
  .ua-ncss .mt-0-md, .ua-ncss .mt0-md {
    margin-top: 0;
  }
  .ua-ncss .mr0-md {
    margin-right: 0;
  }
  .ua-ncss .mb-0-md, .ua-ncss .mb0-md {
    margin-bottom: 0;
  }
  .ua-ncss .ml0-md {
    margin-left: 0;
  }
  .ua-ncss .m0-md {
    margin: 0;
  }
  .ua-ncss .mt1-md {
    margin-top: 4px;
  }
  .ua-ncss .mt-1-md {
    margin-top: -4px;
  }
  .ua-ncss .mr1-md {
    margin-right: 4px;
  }
  .ua-ncss .mb1-md {
    margin-bottom: 4px;
  }
  .ua-ncss .mb-1-md {
    margin-bottom: -4px;
  }
  .ua-ncss .ml1-md {
    margin-left: 4px;
  }
  .ua-ncss .m1-md {
    margin: 4px;
  }
  .ua-ncss .mt2-md {
    margin-top: 8px;
  }
  .ua-ncss .mt-2-md {
    margin-top: -8px;
  }
  .ua-ncss .mr2-md {
    margin-right: 8px;
  }
  .ua-ncss .mb2-md {
    margin-bottom: 8px;
  }
  .ua-ncss .mb-2-md {
    margin-bottom: -8px;
  }
  .ua-ncss .ml2-md {
    margin-left: 8px;
  }
  .ua-ncss .m2-md {
    margin: 8px;
  }
  .ua-ncss .mt3-md {
    margin-top: 12px;
  }
  .ua-ncss .mt-3-md {
    margin-top: -12px;
  }
  .ua-ncss .mr3-md {
    margin-right: 12px;
  }
  .ua-ncss .mb3-md {
    margin-bottom: 12px;
  }
  .ua-ncss .mb-3-md {
    margin-bottom: -12px;
  }
  .ua-ncss .ml3-md {
    margin-left: 12px;
  }
  .ua-ncss .m3-md {
    margin: 12px;
  }
  .ua-ncss .mt4-md {
    margin-top: 16px;
  }
  .ua-ncss .mt-4-md {
    margin-top: -16px;
  }
  .ua-ncss .mr4-md {
    margin-right: 16px;
  }
  .ua-ncss .mb4-md {
    margin-bottom: 16px;
  }
  .ua-ncss .mb-4-md {
    margin-bottom: -16px;
  }
  .ua-ncss .ml4-md {
    margin-left: 16px;
  }
  .ua-ncss .m4-md {
    margin: 16px;
  }
  .ua-ncss .mt5-md {
    margin-top: 20px;
  }
  .ua-ncss .mt-5-md {
    margin-top: -20px;
  }
  .ua-ncss .mr5-md {
    margin-right: 20px;
  }
  .ua-ncss .mb5-md {
    margin-bottom: 20px;
  }
  .ua-ncss .mb-5-md {
    margin-bottom: -20px;
  }
  .ua-ncss .ml5-md {
    margin-left: 20px;
  }
  .ua-ncss .m5-md {
    margin: 20px;
  }
  .ua-ncss .mt6-md {
    margin-top: 24px;
  }
  .ua-ncss .mt-6-md {
    margin-top: -24px;
  }
  .ua-ncss .mr6-md {
    margin-right: 24px;
  }
  .ua-ncss .mb6-md {
    margin-bottom: 24px;
  }
  .ua-ncss .mb-6-md {
    margin-bottom: -24px;
  }
  .ua-ncss .ml6-md {
    margin-left: 24px;
  }
  .ua-ncss .m6-md {
    margin: 24px;
  }
  .ua-ncss .mt7-md {
    margin-top: 28px;
  }
  .ua-ncss .mt-7-md {
    margin-top: -28px;
  }
  .ua-ncss .mr7-md {
    margin-right: 28px;
  }
  .ua-ncss .mb7-md {
    margin-bottom: 28px;
  }
  .ua-ncss .mb-7-md {
    margin-bottom: -28px;
  }
  .ua-ncss .ml7-md {
    margin-left: 28px;
  }
  .ua-ncss .m7-md {
    margin: 28px;
  }
  .ua-ncss .mt8-md {
    margin-top: 32px;
  }
  .ua-ncss .mt-8-md {
    margin-top: -32px;
  }
  .ua-ncss .mr8-md {
    margin-right: 32px;
  }
  .ua-ncss .mb8-md {
    margin-bottom: 32px;
  }
  .ua-ncss .mb-8-md {
    margin-bottom: -32px;
  }
  .ua-ncss .ml8-md {
    margin-left: 32px;
  }
  .ua-ncss .m8-md {
    margin: 32px;
  }
  .ua-ncss .mt9-md {
    margin-top: 36px;
  }
  .ua-ncss .mt-9-md {
    margin-top: -36px;
  }
  .ua-ncss .mr9-md {
    margin-right: 36px;
  }
  .ua-ncss .mb9-md {
    margin-bottom: 36px;
  }
  .ua-ncss .mb-9-md {
    margin-bottom: -36px;
  }
  .ua-ncss .ml9-md {
    margin-left: 36px;
  }
  .ua-ncss .m9-md {
    margin: 36px;
  }
  .ua-ncss .mt10-md {
    margin-top: 40px;
  }
  .ua-ncss .mt-10-md {
    margin-top: -40px;
  }
  .ua-ncss .mr10-md {
    margin-right: 40px;
  }
  .ua-ncss .mb10-md {
    margin-bottom: 40px;
  }
  .ua-ncss .mb-10-md {
    margin-bottom: -40px;
  }
  .ua-ncss .ml10-md {
    margin-left: 40px;
  }
  .ua-ncss .m10-md {
    margin: 40px;
  }
  .ua-ncss .mt11-md {
    margin-top: 44px;
  }
  .ua-ncss .mt-11-md {
    margin-top: -44px;
  }
  .ua-ncss .mr11-md {
    margin-right: 44px;
  }
  .ua-ncss .mb11-md {
    margin-bottom: 44px;
  }
  .ua-ncss .mb-11-md {
    margin-bottom: -44px;
  }
  .ua-ncss .ml11-md {
    margin-left: 44px;
  }
  .ua-ncss .m11-md {
    margin: 44px;
  }
  .ua-ncss .mt12-md {
    margin-top: 48px;
  }
  .ua-ncss .mt-12-md {
    margin-top: -48px;
  }
  .ua-ncss .mr12-md {
    margin-right: 48px;
  }
  .ua-ncss .mb12-md {
    margin-bottom: 48px;
  }
  .ua-ncss .mb-12-md {
    margin-bottom: -48px;
  }
  .ua-ncss .ml12-md {
    margin-left: 48px;
  }
  .ua-ncss .m12-md {
    margin: 48px;
  }
  .ua-ncss .mauto-md {
    margin-left: auto;
    margin-right: auto;
  }
}
@media only screen and (min-width: 1024px) {
  .ua-ncss .mt-0-lg, .ua-ncss .mt0-lg {
    margin-top: 0;
  }
  .ua-ncss .mr0-lg {
    margin-right: 0;
  }
  .ua-ncss .mb-0-lg, .ua-ncss .mb0-lg {
    margin-bottom: 0;
  }
  .ua-ncss .ml0-lg {
    margin-left: 0;
  }
  .ua-ncss .m0-lg {
    margin: 0;
  }
  .ua-ncss .mt1-lg {
    margin-top: 4px;
  }
  .ua-ncss .mt-1-lg {
    margin-top: -4px;
  }
  .ua-ncss .mr1-lg {
    margin-right: 4px;
  }
  .ua-ncss .mb1-lg {
    margin-bottom: 4px;
  }
  .ua-ncss .mb-1-lg {
    margin-bottom: -4px;
  }
  .ua-ncss .ml1-lg {
    margin-left: 4px;
  }
  .ua-ncss .m1-lg {
    margin: 4px;
  }
  .ua-ncss .mt2-lg {
    margin-top: 8px;
  }
  .ua-ncss .mt-2-lg {
    margin-top: -8px;
  }
  .ua-ncss .mr2-lg {
    margin-right: 8px;
  }
  .ua-ncss .mb2-lg {
    margin-bottom: 8px;
  }
  .ua-ncss .mb-2-lg {
    margin-bottom: -8px;
  }
  .ua-ncss .ml2-lg {
    margin-left: 8px;
  }
  .ua-ncss .m2-lg {
    margin: 8px;
  }
  .ua-ncss .mt3-lg {
    margin-top: 12px;
  }
  .ua-ncss .mt-3-lg {
    margin-top: -12px;
  }
  .ua-ncss .mr3-lg {
    margin-right: 12px;
  }
  .ua-ncss .mb3-lg {
    margin-bottom: 12px;
  }
  .ua-ncss .mb-3-lg {
    margin-bottom: -12px;
  }
  .ua-ncss .ml3-lg {
    margin-left: 12px;
  }
  .ua-ncss .m3-lg {
    margin: 12px;
  }
  .ua-ncss .mt4-lg {
    margin-top: 16px;
  }
  .ua-ncss .mt-4-lg {
    margin-top: -16px;
  }
  .ua-ncss .mr4-lg {
    margin-right: 16px;
  }
  .ua-ncss .mb4-lg {
    margin-bottom: 16px;
  }
  .ua-ncss .mb-4-lg {
    margin-bottom: -16px;
  }
  .ua-ncss .ml4-lg {
    margin-left: 16px;
  }
  .ua-ncss .m4-lg {
    margin: 16px;
  }
  .ua-ncss .mt5-lg {
    margin-top: 20px;
  }
  .ua-ncss .mt-5-lg {
    margin-top: -20px;
  }
  .ua-ncss .mr5-lg {
    margin-right: 20px;
  }
  .ua-ncss .mb5-lg {
    margin-bottom: 20px;
  }
  .ua-ncss .mb-5-lg {
    margin-bottom: -20px;
  }
  .ua-ncss .ml5-lg {
    margin-left: 20px;
  }
  .ua-ncss .m5-lg {
    margin: 20px;
  }
  .ua-ncss .mt6-lg {
    margin-top: 24px;
  }
  .ua-ncss .mt-6-lg {
    margin-top: -24px;
  }
  .ua-ncss .mr6-lg {
    margin-right: 24px;
  }
  .ua-ncss .mb6-lg {
    margin-bottom: 24px;
  }
  .ua-ncss .mb-6-lg {
    margin-bottom: -24px;
  }
  .ua-ncss .ml6-lg {
    margin-left: 24px;
  }
  .ua-ncss .m6-lg {
    margin: 24px;
  }
  .ua-ncss .mt7-lg {
    margin-top: 28px;
  }
  .ua-ncss .mt-7-lg {
    margin-top: -28px;
  }
  .ua-ncss .mr7-lg {
    margin-right: 28px;
  }
  .ua-ncss .mb7-lg {
    margin-bottom: 28px;
  }
  .ua-ncss .mb-7-lg {
    margin-bottom: -28px;
  }
  .ua-ncss .ml7-lg {
    margin-left: 28px;
  }
  .ua-ncss .m7-lg {
    margin: 28px;
  }
  .ua-ncss .mt8-lg {
    margin-top: 32px;
  }
  .ua-ncss .mt-8-lg {
    margin-top: -32px;
  }
  .ua-ncss .mr8-lg {
    margin-right: 32px;
  }
  .ua-ncss .mb8-lg {
    margin-bottom: 32px;
  }
  .ua-ncss .mb-8-lg {
    margin-bottom: -32px;
  }
  .ua-ncss .ml8-lg {
    margin-left: 32px;
  }
  .ua-ncss .m8-lg {
    margin: 32px;
  }
  .ua-ncss .mt9-lg {
    margin-top: 36px;
  }
  .ua-ncss .mt-9-lg {
    margin-top: -36px;
  }
  .ua-ncss .mr9-lg {
    margin-right: 36px;
  }
  .ua-ncss .mb9-lg {
    margin-bottom: 36px;
  }
  .ua-ncss .mb-9-lg {
    margin-bottom: -36px;
  }
  .ua-ncss .ml9-lg {
    margin-left: 36px;
  }
  .ua-ncss .m9-lg {
    margin: 36px;
  }
  .ua-ncss .mt10-lg {
    margin-top: 40px;
  }
  .ua-ncss .mt-10-lg {
    margin-top: -40px;
  }
  .ua-ncss .mr10-lg {
    margin-right: 40px;
  }
  .ua-ncss .mb10-lg {
    margin-bottom: 40px;
  }
  .ua-ncss .mb-10-lg {
    margin-bottom: -40px;
  }
  .ua-ncss .ml10-lg {
    margin-left: 40px;
  }
  .ua-ncss .m10-lg {
    margin: 40px;
  }
  .ua-ncss .mt11-lg {
    margin-top: 44px;
  }
  .ua-ncss .mt-11-lg {
    margin-top: -44px;
  }
  .ua-ncss .mr11-lg {
    margin-right: 44px;
  }
  .ua-ncss .mb11-lg {
    margin-bottom: 44px;
  }
  .ua-ncss .mb-11-lg {
    margin-bottom: -44px;
  }
  .ua-ncss .ml11-lg {
    margin-left: 44px;
  }
  .ua-ncss .m11-lg {
    margin: 44px;
  }
  .ua-ncss .mt12-lg {
    margin-top: 48px;
  }
  .ua-ncss .mt-12-lg {
    margin-top: -48px;
  }
  .ua-ncss .mr12-lg {
    margin-right: 48px;
  }
  .ua-ncss .mb12-lg {
    margin-bottom: 48px;
  }
  .ua-ncss .mb-12-lg {
    margin-bottom: -48px;
  }
  .ua-ncss .ml12-lg {
    margin-left: 48px;
  }
  .ua-ncss .m12-lg {
    margin: 48px;
  }
  .ua-ncss .mauto-lg {
    margin-left: auto;
    margin-right: auto;
  }
}
@media only screen and (min-width: 1280px) {
  .ua-ncss .mt-0-xl, .ua-ncss .mt0-xl {
    margin-top: 0;
  }
  .ua-ncss .mr0-xl {
    margin-right: 0;
  }
  .ua-ncss .mb-0-xl, .ua-ncss .mb0-xl {
    margin-bottom: 0;
  }
  .ua-ncss .ml0-xl {
    margin-left: 0;
  }
  .ua-ncss .m0-xl {
    margin: 0;
  }
  .ua-ncss .mt1-xl {
    margin-top: 4px;
  }
  .ua-ncss .mt-1-xl {
    margin-top: -4px;
  }
  .ua-ncss .mr1-xl {
    margin-right: 4px;
  }
  .ua-ncss .mb1-xl {
    margin-bottom: 4px;
  }
  .ua-ncss .mb-1-xl {
    margin-bottom: -4px;
  }
  .ua-ncss .ml1-xl {
    margin-left: 4px;
  }
  .ua-ncss .m1-xl {
    margin: 4px;
  }
  .ua-ncss .mt2-xl {
    margin-top: 8px;
  }
  .ua-ncss .mt-2-xl {
    margin-top: -8px;
  }
  .ua-ncss .mr2-xl {
    margin-right: 8px;
  }
  .ua-ncss .mb2-xl {
    margin-bottom: 8px;
  }
  .ua-ncss .mb-2-xl {
    margin-bottom: -8px;
  }
  .ua-ncss .ml2-xl {
    margin-left: 8px;
  }
  .ua-ncss .m2-xl {
    margin: 8px;
  }
  .ua-ncss .mt3-xl {
    margin-top: 12px;
  }
  .ua-ncss .mt-3-xl {
    margin-top: -12px;
  }
  .ua-ncss .mr3-xl {
    margin-right: 12px;
  }
  .ua-ncss .mb3-xl {
    margin-bottom: 12px;
  }
  .ua-ncss .mb-3-xl {
    margin-bottom: -12px;
  }
  .ua-ncss .ml3-xl {
    margin-left: 12px;
  }
  .ua-ncss .m3-xl {
    margin: 12px;
  }
  .ua-ncss .mt4-xl {
    margin-top: 16px;
  }
  .ua-ncss .mt-4-xl {
    margin-top: -16px;
  }
  .ua-ncss .mr4-xl {
    margin-right: 16px;
  }
  .ua-ncss .mb4-xl {
    margin-bottom: 16px;
  }
  .ua-ncss .mb-4-xl {
    margin-bottom: -16px;
  }
  .ua-ncss .ml4-xl {
    margin-left: 16px;
  }
  .ua-ncss .m4-xl {
    margin: 16px;
  }
  .ua-ncss .mt5-xl {
    margin-top: 20px;
  }
  .ua-ncss .mt-5-xl {
    margin-top: -20px;
  }
  .ua-ncss .mr5-xl {
    margin-right: 20px;
  }
  .ua-ncss .mb5-xl {
    margin-bottom: 20px;
  }
  .ua-ncss .mb-5-xl {
    margin-bottom: -20px;
  }
  .ua-ncss .ml5-xl {
    margin-left: 20px;
  }
  .ua-ncss .m5-xl {
    margin: 20px;
  }
  .ua-ncss .mt6-xl {
    margin-top: 24px;
  }
  .ua-ncss .mt-6-xl {
    margin-top: -24px;
  }
  .ua-ncss .mr6-xl {
    margin-right: 24px;
  }
  .ua-ncss .mb6-xl {
    margin-bottom: 24px;
  }
  .ua-ncss .mb-6-xl {
    margin-bottom: -24px;
  }
  .ua-ncss .ml6-xl {
    margin-left: 24px;
  }
  .ua-ncss .m6-xl {
    margin: 24px;
  }
  .ua-ncss .mt7-xl {
    margin-top: 28px;
  }
  .ua-ncss .mt-7-xl {
    margin-top: -28px;
  }
  .ua-ncss .mr7-xl {
    margin-right: 28px;
  }
  .ua-ncss .mb7-xl {
    margin-bottom: 28px;
  }
  .ua-ncss .mb-7-xl {
    margin-bottom: -28px;
  }
  .ua-ncss .ml7-xl {
    margin-left: 28px;
  }
  .ua-ncss .m7-xl {
    margin: 28px;
  }
  .ua-ncss .mt8-xl {
    margin-top: 32px;
  }
  .ua-ncss .mt-8-xl {
    margin-top: -32px;
  }
  .ua-ncss .mr8-xl {
    margin-right: 32px;
  }
  .ua-ncss .mb8-xl {
    margin-bottom: 32px;
  }
  .ua-ncss .mb-8-xl {
    margin-bottom: -32px;
  }
  .ua-ncss .ml8-xl {
    margin-left: 32px;
  }
  .ua-ncss .m8-xl {
    margin: 32px;
  }
  .ua-ncss .mt9-xl {
    margin-top: 36px;
  }
  .ua-ncss .mt-9-xl {
    margin-top: -36px;
  }
  .ua-ncss .mr9-xl {
    margin-right: 36px;
  }
  .ua-ncss .mb9-xl {
    margin-bottom: 36px;
  }
  .ua-ncss .mb-9-xl {
    margin-bottom: -36px;
  }
  .ua-ncss .ml9-xl {
    margin-left: 36px;
  }
  .ua-ncss .m9-xl {
    margin: 36px;
  }
  .ua-ncss .mt10-xl {
    margin-top: 40px;
  }
  .ua-ncss .mt-10-xl {
    margin-top: -40px;
  }
  .ua-ncss .mr10-xl {
    margin-right: 40px;
  }
  .ua-ncss .mb10-xl {
    margin-bottom: 40px;
  }
  .ua-ncss .mb-10-xl {
    margin-bottom: -40px;
  }
  .ua-ncss .ml10-xl {
    margin-left: 40px;
  }
  .ua-ncss .m10-xl {
    margin: 40px;
  }
  .ua-ncss .mt11-xl {
    margin-top: 44px;
  }
  .ua-ncss .mt-11-xl {
    margin-top: -44px;
  }
  .ua-ncss .mr11-xl {
    margin-right: 44px;
  }
  .ua-ncss .mb11-xl {
    margin-bottom: 44px;
  }
  .ua-ncss .mb-11-xl {
    margin-bottom: -44px;
  }
  .ua-ncss .ml11-xl {
    margin-left: 44px;
  }
  .ua-ncss .m11-xl {
    margin: 44px;
  }
  .ua-ncss .mt12-xl {
    margin-top: 48px;
  }
  .ua-ncss .mt-12-xl {
    margin-top: -48px;
  }
  .ua-ncss .mr12-xl {
    margin-right: 48px;
  }
  .ua-ncss .mb12-xl {
    margin-bottom: 48px;
  }
  .ua-ncss .mb-12-xl {
    margin-bottom: -48px;
  }
  .ua-ncss .ml12-xl {
    margin-left: 48px;
  }
  .ua-ncss .m12-xl {
    margin: 48px;
  }
  .ua-ncss .mauto-xl {
    margin-left: auto;
    margin-right: auto;
  }
}
@media only screen and (min-width: 1440px) {
  .ua-ncss .mt-0-xxl, .ua-ncss .mt0-xxl {
    margin-top: 0;
  }
  .ua-ncss .mr0-xxl {
    margin-right: 0;
  }
  .ua-ncss .mb-0-xxl, .ua-ncss .mb0-xxl {
    margin-bottom: 0;
  }
  .ua-ncss .ml0-xxl {
    margin-left: 0;
  }
  .ua-ncss .m0-xxl {
    margin: 0;
  }
  .ua-ncss .mt1-xxl {
    margin-top: 4px;
  }
  .ua-ncss .mt-1-xxl {
    margin-top: -4px;
  }
  .ua-ncss .mr1-xxl {
    margin-right: 4px;
  }
  .ua-ncss .mb1-xxl {
    margin-bottom: 4px;
  }
  .ua-ncss .mb-1-xxl {
    margin-bottom: -4px;
  }
  .ua-ncss .ml1-xxl {
    margin-left: 4px;
  }
  .ua-ncss .m1-xxl {
    margin: 4px;
  }
  .ua-ncss .mt2-xxl {
    margin-top: 8px;
  }
  .ua-ncss .mt-2-xxl {
    margin-top: -8px;
  }
  .ua-ncss .mr2-xxl {
    margin-right: 8px;
  }
  .ua-ncss .mb2-xxl {
    margin-bottom: 8px;
  }
  .ua-ncss .mb-2-xxl {
    margin-bottom: -8px;
  }
  .ua-ncss .ml2-xxl {
    margin-left: 8px;
  }
  .ua-ncss .m2-xxl {
    margin: 8px;
  }
  .ua-ncss .mt3-xxl {
    margin-top: 12px;
  }
  .ua-ncss .mt-3-xxl {
    margin-top: -12px;
  }
  .ua-ncss .mr3-xxl {
    margin-right: 12px;
  }
  .ua-ncss .mb3-xxl {
    margin-bottom: 12px;
  }
  .ua-ncss .mb-3-xxl {
    margin-bottom: -12px;
  }
  .ua-ncss .ml3-xxl {
    margin-left: 12px;
  }
  .ua-ncss .m3-xxl {
    margin: 12px;
  }
  .ua-ncss .mt4-xxl {
    margin-top: 16px;
  }
  .ua-ncss .mt-4-xxl {
    margin-top: -16px;
  }
  .ua-ncss .mr4-xxl {
    margin-right: 16px;
  }
  .ua-ncss .mb4-xxl {
    margin-bottom: 16px;
  }
  .ua-ncss .mb-4-xxl {
    margin-bottom: -16px;
  }
  .ua-ncss .ml4-xxl {
    margin-left: 16px;
  }
  .ua-ncss .m4-xxl {
    margin: 16px;
  }
  .ua-ncss .mt5-xxl {
    margin-top: 20px;
  }
  .ua-ncss .mt-5-xxl {
    margin-top: -20px;
  }
  .ua-ncss .mr5-xxl {
    margin-right: 20px;
  }
  .ua-ncss .mb5-xxl {
    margin-bottom: 20px;
  }
  .ua-ncss .mb-5-xxl {
    margin-bottom: -20px;
  }
  .ua-ncss .ml5-xxl {
    margin-left: 20px;
  }
  .ua-ncss .m5-xxl {
    margin: 20px;
  }
  .ua-ncss .mt6-xxl {
    margin-top: 24px;
  }
  .ua-ncss .mt-6-xxl {
    margin-top: -24px;
  }
  .ua-ncss .mr6-xxl {
    margin-right: 24px;
  }
  .ua-ncss .mb6-xxl {
    margin-bottom: 24px;
  }
  .ua-ncss .mb-6-xxl {
    margin-bottom: -24px;
  }
  .ua-ncss .ml6-xxl {
    margin-left: 24px;
  }
  .ua-ncss .m6-xxl {
    margin: 24px;
  }
  .ua-ncss .mt7-xxl {
    margin-top: 28px;
  }
  .ua-ncss .mt-7-xxl {
    margin-top: -28px;
  }
  .ua-ncss .mr7-xxl {
    margin-right: 28px;
  }
  .ua-ncss .mb7-xxl {
    margin-bottom: 28px;
  }
  .ua-ncss .mb-7-xxl {
    margin-bottom: -28px;
  }
  .ua-ncss .ml7-xxl {
    margin-left: 28px;
  }
  .ua-ncss .m7-xxl {
    margin: 28px;
  }
  .ua-ncss .mt8-xxl {
    margin-top: 32px;
  }
  .ua-ncss .mt-8-xxl {
    margin-top: -32px;
  }
  .ua-ncss .mr8-xxl {
    margin-right: 32px;
  }
  .ua-ncss .mb8-xxl {
    margin-bottom: 32px;
  }
  .ua-ncss .mb-8-xxl {
    margin-bottom: -32px;
  }
  .ua-ncss .ml8-xxl {
    margin-left: 32px;
  }
  .ua-ncss .m8-xxl {
    margin: 32px;
  }
  .ua-ncss .mt9-xxl {
    margin-top: 36px;
  }
  .ua-ncss .mt-9-xxl {
    margin-top: -36px;
  }
  .ua-ncss .mr9-xxl {
    margin-right: 36px;
  }
  .ua-ncss .mb9-xxl {
    margin-bottom: 36px;
  }
  .ua-ncss .mb-9-xxl {
    margin-bottom: -36px;
  }
  .ua-ncss .ml9-xxl {
    margin-left: 36px;
  }
  .ua-ncss .m9-xxl {
    margin: 36px;
  }
  .ua-ncss .mt10-xxl {
    margin-top: 40px;
  }
  .ua-ncss .mt-10-xxl {
    margin-top: -40px;
  }
  .ua-ncss .mr10-xxl {
    margin-right: 40px;
  }
  .ua-ncss .mb10-xxl {
    margin-bottom: 40px;
  }
  .ua-ncss .mb-10-xxl {
    margin-bottom: -40px;
  }
  .ua-ncss .ml10-xxl {
    margin-left: 40px;
  }
  .ua-ncss .m10-xxl {
    margin: 40px;
  }
  .ua-ncss .mt11-xxl {
    margin-top: 44px;
  }
  .ua-ncss .mt-11-xxl {
    margin-top: -44px;
  }
  .ua-ncss .mr11-xxl {
    margin-right: 44px;
  }
  .ua-ncss .mb11-xxl {
    margin-bottom: 44px;
  }
  .ua-ncss .mb-11-xxl {
    margin-bottom: -44px;
  }
  .ua-ncss .ml11-xxl {
    margin-left: 44px;
  }
  .ua-ncss .m11-xxl {
    margin: 44px;
  }
  .ua-ncss .mt12-xxl {
    margin-top: 48px;
  }
  .ua-ncss .mt-12-xxl {
    margin-top: -48px;
  }
  .ua-ncss .mr12-xxl {
    margin-right: 48px;
  }
  .ua-ncss .mb12-xxl {
    margin-bottom: 48px;
  }
  .ua-ncss .mb-12-xxl {
    margin-bottom: -48px;
  }
  .ua-ncss .ml12-xxl {
    margin-left: 48px;
  }
  .ua-ncss .m12-xxl {
    margin: 48px;
  }
  .ua-ncss .mauto-xxl {
    margin-left: auto;
    margin-right: auto;
  }
}
.ua-ncss .pt0-sm {
  padding-top: 0;
}

.ua-ncss .pr0-sm {
  padding-right: 0;
}

.ua-ncss .pb0-sm {
  padding-bottom: 0;
}

.ua-ncss .pl0-sm {
  padding-left: 0;
}

.ua-ncss .prl0-sm {
  padding-right: 0;
  padding-left: 0;
}

.ua-ncss .p0-sm {
  padding: 0;
}

.ua-ncss .pt1-sm {
  padding-top: 4px;
}

.ua-ncss .pr1-sm {
  padding-right: 4px;
}

.ua-ncss .pb1-sm {
  padding-bottom: 4px;
}

.ua-ncss .pl1-sm {
  padding-left: 4px;
}

.ua-ncss .prl1-sm {
  padding-right: 4px;
  padding-left: 4px;
}

.ua-ncss .p1-sm {
  padding: 4px;
}

.ua-ncss .pt2-sm {
  padding-top: 8px;
}

.ua-ncss .pr2-sm {
  padding-right: 8px;
}

.ua-ncss .pb2-sm {
  padding-bottom: 8px;
}

.ua-ncss .pl2-sm {
  padding-left: 8px;
}

.ua-ncss .prl2-sm {
  padding-right: 8px;
  padding-left: 8px;
}

.ua-ncss .p2-sm {
  padding: 8px;
}

.ua-ncss .pt3-sm {
  padding-top: 12px;
}

.ua-ncss .pr3-sm {
  padding-right: 12px;
}

.ua-ncss .pb3-sm {
  padding-bottom: 12px;
}

.ua-ncss .pl3-sm {
  padding-left: 12px;
}

.ua-ncss .prl3-sm {
  padding-right: 12px;
  padding-left: 12px;
}

.ua-ncss .p3-sm {
  padding: 12px;
}

.ua-ncss .pt4-sm {
  padding-top: 16px;
}

.ua-ncss .pr4-sm {
  padding-right: 16px;
}

.ua-ncss .pb4-sm {
  padding-bottom: 16px;
}

.ua-ncss .pl4-sm {
  padding-left: 16px;
}

.ua-ncss .prl4-sm {
  padding-right: 16px;
  padding-left: 16px;
}

.ua-ncss .p4-sm {
  padding: 16px;
}

.ua-ncss .pt5-sm {
  padding-top: 20px;
}

.ua-ncss .pr5-sm {
  padding-right: 20px;
}

.ua-ncss .pb5-sm {
  padding-bottom: 20px;
}

.ua-ncss .pl5-sm {
  padding-left: 20px;
}

.ua-ncss .prl5-sm {
  padding-right: 20px;
  padding-left: 20px;
}

.ua-ncss .p5-sm {
  padding: 20px;
}

.ua-ncss .pt6-sm {
  padding-top: 24px;
}

.ua-ncss .pr6-sm {
  padding-right: 24px;
}

.ua-ncss .pb6-sm {
  padding-bottom: 24px;
}

.ua-ncss .pl6-sm {
  padding-left: 24px;
}

.ua-ncss .prl6-sm {
  padding-right: 24px;
  padding-left: 24px;
}

.ua-ncss .p6-sm {
  padding: 24px;
}

.ua-ncss .pt7-sm {
  padding-top: 28px;
}

.ua-ncss .pr7-sm {
  padding-right: 28px;
}

.ua-ncss .pb7-sm {
  padding-bottom: 28px;
}

.ua-ncss .pl7-sm {
  padding-left: 28px;
}

.ua-ncss .prl7-sm {
  padding-right: 28px;
  padding-left: 28px;
}

.ua-ncss .p7-sm {
  padding: 28px;
}

.ua-ncss .pt8-sm {
  padding-top: 32px;
}

.ua-ncss .pr8-sm {
  padding-right: 32px;
}

.ua-ncss .pb8-sm {
  padding-bottom: 32px;
}

.ua-ncss .pl8-sm {
  padding-left: 32px;
}

.ua-ncss .prl8-sm {
  padding-right: 32px;
  padding-left: 32px;
}

.ua-ncss .p8-sm {
  padding: 32px;
}

.ua-ncss .pt9-sm {
  padding-top: 36px;
}

.ua-ncss .pr9-sm {
  padding-right: 36px;
}

.ua-ncss .pb9-sm {
  padding-bottom: 36px;
}

.ua-ncss .pl9-sm {
  padding-left: 36px;
}

.ua-ncss .prl9-sm {
  padding-right: 36px;
  padding-left: 36px;
}

.ua-ncss .p9-sm {
  padding: 36px;
}

.ua-ncss .pt10-sm {
  padding-top: 40px;
}

.ua-ncss .pr10-sm {
  padding-right: 40px;
}

.ua-ncss .pb10-sm {
  padding-bottom: 40px;
}

.ua-ncss .pl10-sm {
  padding-left: 40px;
}

.ua-ncss .prl10-sm {
  padding-right: 40px;
  padding-left: 40px;
}

.ua-ncss .p10-sm {
  padding: 40px;
}

.ua-ncss .pt11-sm {
  padding-top: 44px;
}

.ua-ncss .pr11-sm {
  padding-right: 44px;
}

.ua-ncss .pb11-sm {
  padding-bottom: 44px;
}

.ua-ncss .pl11-sm {
  padding-left: 44px;
}

.ua-ncss .prl11-sm {
  padding-right: 44px;
  padding-left: 44px;
}

.ua-ncss .p11-sm {
  padding: 44px;
}

.ua-ncss .pt12-sm {
  padding-top: 48px;
}

.ua-ncss .pr12-sm {
  padding-right: 48px;
}

.ua-ncss .pb12-sm {
  padding-bottom: 48px;
}

.ua-ncss .pl12-sm {
  padding-left: 48px;
}

.ua-ncss .prl12-sm {
  padding-right: 48px;
  padding-left: 48px;
}

.ua-ncss .p12-sm {
  padding: 48px;
}

@media only screen and (min-width: 640px) {
  .ua-ncss .pt0-md {
    padding-top: 0;
  }
  .ua-ncss .pr0-md {
    padding-right: 0;
  }
  .ua-ncss .pb0-md {
    padding-bottom: 0;
  }
  .ua-ncss .pl0-md {
    padding-left: 0;
  }
  .ua-ncss .prl0-md {
    padding-right: 0;
    padding-left: 0;
  }
  .ua-ncss .p0-md {
    padding: 0;
  }
  .ua-ncss .pt1-md {
    padding-top: 4px;
  }
  .ua-ncss .pr1-md {
    padding-right: 4px;
  }
  .ua-ncss .pb1-md {
    padding-bottom: 4px;
  }
  .ua-ncss .pl1-md {
    padding-left: 4px;
  }
  .ua-ncss .prl1-md {
    padding-right: 4px;
    padding-left: 4px;
  }
  .ua-ncss .p1-md {
    padding: 4px;
  }
  .ua-ncss .pt2-md {
    padding-top: 8px;
  }
  .ua-ncss .pr2-md {
    padding-right: 8px;
  }
  .ua-ncss .pb2-md {
    padding-bottom: 8px;
  }
  .ua-ncss .pl2-md {
    padding-left: 8px;
  }
  .ua-ncss .prl2-md {
    padding-right: 8px;
    padding-left: 8px;
  }
  .ua-ncss .p2-md {
    padding: 8px;
  }
  .ua-ncss .pt3-md {
    padding-top: 12px;
  }
  .ua-ncss .pr3-md {
    padding-right: 12px;
  }
  .ua-ncss .pb3-md {
    padding-bottom: 12px;
  }
  .ua-ncss .pl3-md {
    padding-left: 12px;
  }
  .ua-ncss .prl3-md {
    padding-right: 12px;
    padding-left: 12px;
  }
  .ua-ncss .p3-md {
    padding: 12px;
  }
  .ua-ncss .pt4-md {
    padding-top: 16px;
  }
  .ua-ncss .pr4-md {
    padding-right: 16px;
  }
  .ua-ncss .pb4-md {
    padding-bottom: 16px;
  }
  .ua-ncss .pl4-md {
    padding-left: 16px;
  }
  .ua-ncss .prl4-md {
    padding-right: 16px;
    padding-left: 16px;
  }
  .ua-ncss .p4-md {
    padding: 16px;
  }
  .ua-ncss .pt5-md {
    padding-top: 20px;
  }
  .ua-ncss .pr5-md {
    padding-right: 20px;
  }
  .ua-ncss .pb5-md {
    padding-bottom: 20px;
  }
  .ua-ncss .pl5-md {
    padding-left: 20px;
  }
  .ua-ncss .prl5-md {
    padding-right: 20px;
    padding-left: 20px;
  }
  .ua-ncss .p5-md {
    padding: 20px;
  }
  .ua-ncss .pt6-md {
    padding-top: 24px;
  }
  .ua-ncss .pr6-md {
    padding-right: 24px;
  }
  .ua-ncss .pb6-md {
    padding-bottom: 24px;
  }
  .ua-ncss .pl6-md {
    padding-left: 24px;
  }
  .ua-ncss .prl6-md {
    padding-right: 24px;
    padding-left: 24px;
  }
  .ua-ncss .p6-md {
    padding: 24px;
  }
  .ua-ncss .pt7-md {
    padding-top: 28px;
  }
  .ua-ncss .pr7-md {
    padding-right: 28px;
  }
  .ua-ncss .pb7-md {
    padding-bottom: 28px;
  }
  .ua-ncss .pl7-md {
    padding-left: 28px;
  }
  .ua-ncss .prl7-md {
    padding-right: 28px;
    padding-left: 28px;
  }
  .ua-ncss .p7-md {
    padding: 28px;
  }
  .ua-ncss .pt8-md {
    padding-top: 32px;
  }
  .ua-ncss .pr8-md {
    padding-right: 32px;
  }
  .ua-ncss .pb8-md {
    padding-bottom: 32px;
  }
  .ua-ncss .pl8-md {
    padding-left: 32px;
  }
  .ua-ncss .prl8-md {
    padding-right: 32px;
    padding-left: 32px;
  }
  .ua-ncss .p8-md {
    padding: 32px;
  }
  .ua-ncss .pt9-md {
    padding-top: 36px;
  }
  .ua-ncss .pr9-md {
    padding-right: 36px;
  }
  .ua-ncss .pb9-md {
    padding-bottom: 36px;
  }
  .ua-ncss .pl9-md {
    padding-left: 36px;
  }
  .ua-ncss .prl9-md {
    padding-right: 36px;
    padding-left: 36px;
  }
  .ua-ncss .p9-md {
    padding: 36px;
  }
  .ua-ncss .pt10-md {
    padding-top: 40px;
  }
  .ua-ncss .pr10-md {
    padding-right: 40px;
  }
  .ua-ncss .pb10-md {
    padding-bottom: 40px;
  }
  .ua-ncss .pl10-md {
    padding-left: 40px;
  }
  .ua-ncss .prl10-md {
    padding-right: 40px;
    padding-left: 40px;
  }
  .ua-ncss .p10-md {
    padding: 40px;
  }
  .ua-ncss .pt11-md {
    padding-top: 44px;
  }
  .ua-ncss .pr11-md {
    padding-right: 44px;
  }
  .ua-ncss .pb11-md {
    padding-bottom: 44px;
  }
  .ua-ncss .pl11-md {
    padding-left: 44px;
  }
  .ua-ncss .prl11-md {
    padding-right: 44px;
    padding-left: 44px;
  }
  .ua-ncss .p11-md {
    padding: 44px;
  }
  .ua-ncss .pt12-md {
    padding-top: 48px;
  }
  .ua-ncss .pr12-md {
    padding-right: 48px;
  }
  .ua-ncss .pb12-md {
    padding-bottom: 48px;
  }
  .ua-ncss .pl12-md {
    padding-left: 48px;
  }
  .ua-ncss .prl12-md {
    padding-right: 48px;
    padding-left: 48px;
  }
  .ua-ncss .p12-md {
    padding: 48px;
  }
}
@media only screen and (min-width: 1024px) {
  .ua-ncss .pt0-lg {
    padding-top: 0;
  }
  .ua-ncss .pr0-lg {
    padding-right: 0;
  }
  .ua-ncss .pb0-lg {
    padding-bottom: 0;
  }
  .ua-ncss .pl0-lg {
    padding-left: 0;
  }
  .ua-ncss .prl0-lg {
    padding-right: 0;
    padding-left: 0;
  }
  .ua-ncss .p0-lg {
    padding: 0;
  }
  .ua-ncss .pt1-lg {
    padding-top: 4px;
  }
  .ua-ncss .pr1-lg {
    padding-right: 4px;
  }
  .ua-ncss .pb1-lg {
    padding-bottom: 4px;
  }
  .ua-ncss .pl1-lg {
    padding-left: 4px;
  }
  .ua-ncss .prl1-lg {
    padding-right: 4px;
    padding-left: 4px;
  }
  .ua-ncss .p1-lg {
    padding: 4px;
  }
  .ua-ncss .pt2-lg {
    padding-top: 8px;
  }
  .ua-ncss .pr2-lg {
    padding-right: 8px;
  }
  .ua-ncss .pb2-lg {
    padding-bottom: 8px;
  }
  .ua-ncss .pl2-lg {
    padding-left: 8px;
  }
  .ua-ncss .prl2-lg {
    padding-right: 8px;
    padding-left: 8px;
  }
  .ua-ncss .p2-lg {
    padding: 8px;
  }
  .ua-ncss .pt3-lg {
    padding-top: 12px;
  }
  .ua-ncss .pr3-lg {
    padding-right: 12px;
  }
  .ua-ncss .pb3-lg {
    padding-bottom: 12px;
  }
  .ua-ncss .pl3-lg {
    padding-left: 12px;
  }
  .ua-ncss .prl3-lg {
    padding-right: 12px;
    padding-left: 12px;
  }
  .ua-ncss .p3-lg {
    padding: 12px;
  }
  .ua-ncss .pt4-lg {
    padding-top: 16px;
  }
  .ua-ncss .pr4-lg {
    padding-right: 16px;
  }
  .ua-ncss .pb4-lg {
    padding-bottom: 16px;
  }
  .ua-ncss .pl4-lg {
    padding-left: 16px;
  }
  .ua-ncss .prl4-lg {
    padding-right: 16px;
    padding-left: 16px;
  }
  .ua-ncss .p4-lg {
    padding: 16px;
  }
  .ua-ncss .pt5-lg {
    padding-top: 20px;
  }
  .ua-ncss .pr5-lg {
    padding-right: 20px;
  }
  .ua-ncss .pb5-lg {
    padding-bottom: 20px;
  }
  .ua-ncss .pl5-lg {
    padding-left: 20px;
  }
  .ua-ncss .prl5-lg {
    padding-right: 20px;
    padding-left: 20px;
  }
  .ua-ncss .p5-lg {
    padding: 20px;
  }
  .ua-ncss .pt6-lg {
    padding-top: 24px;
  }
  .ua-ncss .pr6-lg {
    padding-right: 24px;
  }
  .ua-ncss .pb6-lg {
    padding-bottom: 24px;
  }
  .ua-ncss .pl6-lg {
    padding-left: 24px;
  }
  .ua-ncss .prl6-lg {
    padding-right: 24px;
    padding-left: 24px;
  }
  .ua-ncss .p6-lg {
    padding: 24px;
  }
  .ua-ncss .pt7-lg {
    padding-top: 28px;
  }
  .ua-ncss .pr7-lg {
    padding-right: 28px;
  }
  .ua-ncss .pb7-lg {
    padding-bottom: 28px;
  }
  .ua-ncss .pl7-lg {
    padding-left: 28px;
  }
  .ua-ncss .prl7-lg {
    padding-right: 28px;
    padding-left: 28px;
  }
  .ua-ncss .p7-lg {
    padding: 28px;
  }
  .ua-ncss .pt8-lg {
    padding-top: 32px;
  }
  .ua-ncss .pr8-lg {
    padding-right: 32px;
  }
  .ua-ncss .pb8-lg {
    padding-bottom: 32px;
  }
  .ua-ncss .pl8-lg {
    padding-left: 32px;
  }
  .ua-ncss .prl8-lg {
    padding-right: 32px;
    padding-left: 32px;
  }
  .ua-ncss .p8-lg {
    padding: 32px;
  }
  .ua-ncss .pt9-lg {
    padding-top: 36px;
  }
  .ua-ncss .pr9-lg {
    padding-right: 36px;
  }
  .ua-ncss .pb9-lg {
    padding-bottom: 36px;
  }
  .ua-ncss .pl9-lg {
    padding-left: 36px;
  }
  .ua-ncss .prl9-lg {
    padding-right: 36px;
    padding-left: 36px;
  }
  .ua-ncss .p9-lg {
    padding: 36px;
  }
  .ua-ncss .pt10-lg {
    padding-top: 40px;
  }
  .ua-ncss .pr10-lg {
    padding-right: 40px;
  }
  .ua-ncss .pb10-lg {
    padding-bottom: 40px;
  }
  .ua-ncss .pl10-lg {
    padding-left: 40px;
  }
  .ua-ncss .prl10-lg {
    padding-right: 40px;
    padding-left: 40px;
  }
  .ua-ncss .p10-lg {
    padding: 40px;
  }
  .ua-ncss .pt11-lg {
    padding-top: 44px;
  }
  .ua-ncss .pr11-lg {
    padding-right: 44px;
  }
  .ua-ncss .pb11-lg {
    padding-bottom: 44px;
  }
  .ua-ncss .pl11-lg {
    padding-left: 44px;
  }
  .ua-ncss .prl11-lg {
    padding-right: 44px;
    padding-left: 44px;
  }
  .ua-ncss .p11-lg {
    padding: 44px;
  }
  .ua-ncss .pt12-lg {
    padding-top: 48px;
  }
  .ua-ncss .pr12-lg {
    padding-right: 48px;
  }
  .ua-ncss .pb12-lg {
    padding-bottom: 48px;
  }
  .ua-ncss .pl12-lg {
    padding-left: 48px;
  }
  .ua-ncss .prl12-lg {
    padding-right: 48px;
    padding-left: 48px;
  }
  .ua-ncss .p12-lg {
    padding: 48px;
  }
}
@media only screen and (min-width: 1280px) {
  .ua-ncss .pt0-xl {
    padding-top: 0;
  }
  .ua-ncss .pr0-xl {
    padding-right: 0;
  }
  .ua-ncss .pb0-xl {
    padding-bottom: 0;
  }
  .ua-ncss .pl0-xl {
    padding-left: 0;
  }
  .ua-ncss .prl0-xl {
    padding-right: 0;
    padding-left: 0;
  }
  .ua-ncss .p0-xl {
    padding: 0;
  }
  .ua-ncss .pt1-xl {
    padding-top: 4px;
  }
  .ua-ncss .pr1-xl {
    padding-right: 4px;
  }
  .ua-ncss .pb1-xl {
    padding-bottom: 4px;
  }
  .ua-ncss .pl1-xl {
    padding-left: 4px;
  }
  .ua-ncss .prl1-xl {
    padding-right: 4px;
    padding-left: 4px;
  }
  .ua-ncss .p1-xl {
    padding: 4px;
  }
  .ua-ncss .pt2-xl {
    padding-top: 8px;
  }
  .ua-ncss .pr2-xl {
    padding-right: 8px;
  }
  .ua-ncss .pb2-xl {
    padding-bottom: 8px;
  }
  .ua-ncss .pl2-xl {
    padding-left: 8px;
  }
  .ua-ncss .prl2-xl {
    padding-right: 8px;
    padding-left: 8px;
  }
  .ua-ncss .p2-xl {
    padding: 8px;
  }
  .ua-ncss .pt3-xl {
    padding-top: 12px;
  }
  .ua-ncss .pr3-xl {
    padding-right: 12px;
  }
  .ua-ncss .pb3-xl {
    padding-bottom: 12px;
  }
  .ua-ncss .pl3-xl {
    padding-left: 12px;
  }
  .ua-ncss .prl3-xl {
    padding-right: 12px;
    padding-left: 12px;
  }
  .ua-ncss .p3-xl {
    padding: 12px;
  }
  .ua-ncss .pt4-xl {
    padding-top: 16px;
  }
  .ua-ncss .pr4-xl {
    padding-right: 16px;
  }
  .ua-ncss .pb4-xl {
    padding-bottom: 16px;
  }
  .ua-ncss .pl4-xl {
    padding-left: 16px;
  }
  .ua-ncss .prl4-xl {
    padding-right: 16px;
    padding-left: 16px;
  }
  .ua-ncss .p4-xl {
    padding: 16px;
  }
  .ua-ncss .pt5-xl {
    padding-top: 20px;
  }
  .ua-ncss .pr5-xl {
    padding-right: 20px;
  }
  .ua-ncss .pb5-xl {
    padding-bottom: 20px;
  }
  .ua-ncss .pl5-xl {
    padding-left: 20px;
  }
  .ua-ncss .prl5-xl {
    padding-right: 20px;
    padding-left: 20px;
  }
  .ua-ncss .p5-xl {
    padding: 20px;
  }
  .ua-ncss .pt6-xl {
    padding-top: 24px;
  }
  .ua-ncss .pr6-xl {
    padding-right: 24px;
  }
  .ua-ncss .pb6-xl {
    padding-bottom: 24px;
  }
  .ua-ncss .pl6-xl {
    padding-left: 24px;
  }
  .ua-ncss .prl6-xl {
    padding-right: 24px;
    padding-left: 24px;
  }
  .ua-ncss .p6-xl {
    padding: 24px;
  }
  .ua-ncss .pt7-xl {
    padding-top: 28px;
  }
  .ua-ncss .pr7-xl {
    padding-right: 28px;
  }
  .ua-ncss .pb7-xl {
    padding-bottom: 28px;
  }
  .ua-ncss .pl7-xl {
    padding-left: 28px;
  }
  .ua-ncss .prl7-xl {
    padding-right: 28px;
    padding-left: 28px;
  }
  .ua-ncss .p7-xl {
    padding: 28px;
  }
  .ua-ncss .pt8-xl {
    padding-top: 32px;
  }
  .ua-ncss .pr8-xl {
    padding-right: 32px;
  }
  .ua-ncss .pb8-xl {
    padding-bottom: 32px;
  }
  .ua-ncss .pl8-xl {
    padding-left: 32px;
  }
  .ua-ncss .prl8-xl {
    padding-right: 32px;
    padding-left: 32px;
  }
  .ua-ncss .p8-xl {
    padding: 32px;
  }
  .ua-ncss .pt9-xl {
    padding-top: 36px;
  }
  .ua-ncss .pr9-xl {
    padding-right: 36px;
  }
  .ua-ncss .pb9-xl {
    padding-bottom: 36px;
  }
  .ua-ncss .pl9-xl {
    padding-left: 36px;
  }
  .ua-ncss .prl9-xl {
    padding-right: 36px;
    padding-left: 36px;
  }
  .ua-ncss .p9-xl {
    padding: 36px;
  }
  .ua-ncss .pt10-xl {
    padding-top: 40px;
  }
  .ua-ncss .pr10-xl {
    padding-right: 40px;
  }
  .ua-ncss .pb10-xl {
    padding-bottom: 40px;
  }
  .ua-ncss .pl10-xl {
    padding-left: 40px;
  }
  .ua-ncss .prl10-xl {
    padding-right: 40px;
    padding-left: 40px;
  }
  .ua-ncss .p10-xl {
    padding: 40px;
  }
  .ua-ncss .pt11-xl {
    padding-top: 44px;
  }
  .ua-ncss .pr11-xl {
    padding-right: 44px;
  }
  .ua-ncss .pb11-xl {
    padding-bottom: 44px;
  }
  .ua-ncss .pl11-xl {
    padding-left: 44px;
  }
  .ua-ncss .prl11-xl {
    padding-right: 44px;
    padding-left: 44px;
  }
  .ua-ncss .p11-xl {
    padding: 44px;
  }
  .ua-ncss .pt12-xl {
    padding-top: 48px;
  }
  .ua-ncss .pr12-xl {
    padding-right: 48px;
  }
  .ua-ncss .pb12-xl {
    padding-bottom: 48px;
  }
  .ua-ncss .pl12-xl {
    padding-left: 48px;
  }
  .ua-ncss .prl12-xl {
    padding-right: 48px;
    padding-left: 48px;
  }
  .ua-ncss .p12-xl {
    padding: 48px;
  }
}
@media only screen and (min-width: 1440px) {
  .ua-ncss .pt0-xxl {
    padding-top: 0;
  }
  .ua-ncss .pr0-xxl {
    padding-right: 0;
  }
  .ua-ncss .pb0-xxl {
    padding-bottom: 0;
  }
  .ua-ncss .pl0-xxl {
    padding-left: 0;
  }
  .ua-ncss .prl0-xxl {
    padding-right: 0;
    padding-left: 0;
  }
  .ua-ncss .p0-xxl {
    padding: 0;
  }
  .ua-ncss .pt1-xxl {
    padding-top: 4px;
  }
  .ua-ncss .pr1-xxl {
    padding-right: 4px;
  }
  .ua-ncss .pb1-xxl {
    padding-bottom: 4px;
  }
  .ua-ncss .pl1-xxl {
    padding-left: 4px;
  }
  .ua-ncss .prl1-xxl {
    padding-right: 4px;
    padding-left: 4px;
  }
  .ua-ncss .p1-xxl {
    padding: 4px;
  }
  .ua-ncss .pt2-xxl {
    padding-top: 8px;
  }
  .ua-ncss .pr2-xxl {
    padding-right: 8px;
  }
  .ua-ncss .pb2-xxl {
    padding-bottom: 8px;
  }
  .ua-ncss .pl2-xxl {
    padding-left: 8px;
  }
  .ua-ncss .prl2-xxl {
    padding-right: 8px;
    padding-left: 8px;
  }
  .ua-ncss .p2-xxl {
    padding: 8px;
  }
  .ua-ncss .pt3-xxl {
    padding-top: 12px;
  }
  .ua-ncss .pr3-xxl {
    padding-right: 12px;
  }
  .ua-ncss .pb3-xxl {
    padding-bottom: 12px;
  }
  .ua-ncss .pl3-xxl {
    padding-left: 12px;
  }
  .ua-ncss .prl3-xxl {
    padding-right: 12px;
    padding-left: 12px;
  }
  .ua-ncss .p3-xxl {
    padding: 12px;
  }
  .ua-ncss .pt4-xxl {
    padding-top: 16px;
  }
  .ua-ncss .pr4-xxl {
    padding-right: 16px;
  }
  .ua-ncss .pb4-xxl {
    padding-bottom: 16px;
  }
  .ua-ncss .pl4-xxl {
    padding-left: 16px;
  }
  .ua-ncss .prl4-xxl {
    padding-right: 16px;
    padding-left: 16px;
  }
  .ua-ncss .p4-xxl {
    padding: 16px;
  }
  .ua-ncss .pt5-xxl {
    padding-top: 20px;
  }
  .ua-ncss .pr5-xxl {
    padding-right: 20px;
  }
  .ua-ncss .pb5-xxl {
    padding-bottom: 20px;
  }
  .ua-ncss .pl5-xxl {
    padding-left: 20px;
  }
  .ua-ncss .prl5-xxl {
    padding-right: 20px;
    padding-left: 20px;
  }
  .ua-ncss .p5-xxl {
    padding: 20px;
  }
  .ua-ncss .pt6-xxl {
    padding-top: 24px;
  }
  .ua-ncss .pr6-xxl {
    padding-right: 24px;
  }
  .ua-ncss .pb6-xxl {
    padding-bottom: 24px;
  }
  .ua-ncss .pl6-xxl {
    padding-left: 24px;
  }
  .ua-ncss .prl6-xxl {
    padding-right: 24px;
    padding-left: 24px;
  }
  .ua-ncss .p6-xxl {
    padding: 24px;
  }
  .ua-ncss .pt7-xxl {
    padding-top: 28px;
  }
  .ua-ncss .pr7-xxl {
    padding-right: 28px;
  }
  .ua-ncss .pb7-xxl {
    padding-bottom: 28px;
  }
  .ua-ncss .pl7-xxl {
    padding-left: 28px;
  }
  .ua-ncss .prl7-xxl {
    padding-right: 28px;
    padding-left: 28px;
  }
  .ua-ncss .p7-xxl {
    padding: 28px;
  }
  .ua-ncss .pt8-xxl {
    padding-top: 32px;
  }
  .ua-ncss .pr8-xxl {
    padding-right: 32px;
  }
  .ua-ncss .pb8-xxl {
    padding-bottom: 32px;
  }
  .ua-ncss .pl8-xxl {
    padding-left: 32px;
  }
  .ua-ncss .prl8-xxl {
    padding-right: 32px;
    padding-left: 32px;
  }
  .ua-ncss .p8-xxl {
    padding: 32px;
  }
  .ua-ncss .pt9-xxl {
    padding-top: 36px;
  }
  .ua-ncss .pr9-xxl {
    padding-right: 36px;
  }
  .ua-ncss .pb9-xxl {
    padding-bottom: 36px;
  }
  .ua-ncss .pl9-xxl {
    padding-left: 36px;
  }
  .ua-ncss .prl9-xxl {
    padding-right: 36px;
    padding-left: 36px;
  }
  .ua-ncss .p9-xxl {
    padding: 36px;
  }
  .ua-ncss .pt10-xxl {
    padding-top: 40px;
  }
  .ua-ncss .pr10-xxl {
    padding-right: 40px;
  }
  .ua-ncss .pb10-xxl {
    padding-bottom: 40px;
  }
  .ua-ncss .pl10-xxl {
    padding-left: 40px;
  }
  .ua-ncss .prl10-xxl {
    padding-right: 40px;
    padding-left: 40px;
  }
  .ua-ncss .p10-xxl {
    padding: 40px;
  }
  .ua-ncss .pt11-xxl {
    padding-top: 44px;
  }
  .ua-ncss .pr11-xxl {
    padding-right: 44px;
  }
  .ua-ncss .pb11-xxl {
    padding-bottom: 44px;
  }
  .ua-ncss .pl11-xxl {
    padding-left: 44px;
  }
  .ua-ncss .prl11-xxl {
    padding-right: 44px;
    padding-left: 44px;
  }
  .ua-ncss .p11-xxl {
    padding: 44px;
  }
  .ua-ncss .pt12-xxl {
    padding-top: 48px;
  }
  .ua-ncss .pr12-xxl {
    padding-right: 48px;
  }
  .ua-ncss .pb12-xxl {
    padding-bottom: 48px;
  }
  .ua-ncss .pl12-xxl {
    padding-left: 48px;
  }
  .ua-ncss .prl12-xxl {
    padding-right: 48px;
    padding-left: 48px;
  }
  .ua-ncss .p12-xxl {
    padding: 48px;
  }
}
.ua-ncss .ta-sm-r {
  text-align: right;
}

.ua-ncss .ta-sm-c {
  text-align: center;
}

.ua-ncss .ta-sm-l {
  text-align: left;
}

@media only screen and (min-width: 640px) {
  .ua-ncss .ta-md-r {
    text-align: right;
  }
  .ua-ncss .ta-md-c {
    text-align: center;
  }
  .ua-ncss .ta-md-l {
    text-align: left;
  }
}
@media only screen and (min-width: 1024px) {
  .ua-ncss .ta-lg-r {
    text-align: right;
  }
  .ua-ncss .ta-lg-c {
    text-align: center;
  }
  .ua-ncss .ta-lg-l {
    text-align: left;
  }
}
@media only screen and (min-width: 1280px) {
  .ua-ncss .ta-xl-r {
    text-align: right;
  }
  .ua-ncss .ta-xl-c {
    text-align: center;
  }
  .ua-ncss .ta-xl-l {
    text-align: left;
  }
}
@media only screen and (min-width: 1440px) {
  .ua-ncss .ta-xxl-r {
    text-align: right;
  }
  .ua-ncss .ta-xxl-c {
    text-align: center;
  }
  .ua-ncss .ta-xxl-l {
    text-align: left;
  }
}
.ua-ncss .va-sm-t {
  vertical-align: top;
}

.ua-ncss .va-sm-m {
  vertical-align: middle;
}

.ua-ncss .va-sm-b {
  vertical-align: bottom;
}

@media only screen and (min-width: 640px) {
  .ua-ncss .va-md-t {
    vertical-align: top;
  }
  .ua-ncss .va-md-m {
    vertical-align: middle;
  }
  .ua-ncss .va-md-b {
    vertical-align: bottom;
  }
}
@media only screen and (min-width: 1024px) {
  .ua-ncss .va-lg-t {
    vertical-align: top;
  }
  .ua-ncss .va-lg-m {
    vertical-align: middle;
  }
  .ua-ncss .va-lg-b {
    vertical-align: bottom;
  }
}
@media only screen and (min-width: 1280px) {
  .ua-ncss .va-xl-t {
    vertical-align: top;
  }
  .ua-ncss .va-xl-m {
    vertical-align: middle;
  }
  .ua-ncss .va-xl-b {
    vertical-align: bottom;
  }
}
@media only screen and (min-width: 1440px) {
  .ua-ncss .va-xxl-t {
    vertical-align: top;
  }
  .ua-ncss .va-xxl-m {
    vertical-align: middle;
  }
  .ua-ncss .va-xxl-b {
    vertical-align: bottom;
  }
}
.ua-ncss .u-clearfix:after, .ua-ncss .u-clearfix:before {
  content: "";
  display: table;
}

.ua-ncss .u-clearfix:after {
  clear: both;
}

.ua-ncss .u-bold, .ua-ncss strong {
  font-weight: 700;
}

.ua-ncss .u-medium {
  font-weight: 500;
}

.ua-ncss .u-italic, .ua-ncss em {
  font-style: italic;
}

.ua-ncss .u-underline {
  text-decoration: underline;
}

.ua-ncss .u-uppercase {
  text-transform: uppercase;
}

.ua-ncss .u-lowercase {
  text-transform: lowercase;
}

.ua-ncss .u-capitalize {
  text-transform: capitalize;
}

.ua-ncss .u-strikethrough {
  text-decoration: line-through;
}

.ua-ncss .u-no-ws {
  overflow: hidden;
  white-space: nowrap;
}

.ua-ncss .u-no-ws-e {
  overflow: hidden;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
}

.ua-ncss .u-full-width {
  width: 100%;
}

.ua-ncss .u-max-width {
  max-width: 100%;
}

.ua-ncss .u-no-max-width {
  max-width: none;
}

.ua-ncss .u-full-height {
  height: 100%;
}

.ua-ncss .u-max-height {
  max-height: 100%;
}

.ua-ncss .u-rounded {
  -webkit-border-radius: 2px;
  border-radius: 2px;
}

.ua-ncss .u-cursor-default {
  cursor: default;
}

.ua-ncss .u-cursor-pointer {
  cursor: pointer;
}

.ua-ncss .inactive {
  opacity: 0.2;
}

.ua-ncss .disabled, .ua-ncss [disabled] {
  cursor: not-allowed;
}

.ua-ncss .bs1 {
  border-spacing: 0 4px;
}

.ua-ncss .bs2 {
  border-spacing: 0 8px;
}

.ua-ncss .bs3 {
  border-spacing: 0 12px;
}

.ua-ncss .bs4 {
  border-spacing: 0 16px;
}

.ua-ncss .bs5 {
  border-spacing: 0 20px;
}

.ua-ncss .bs6 {
  border-spacing: 0 24px;
}

.ua-ncss .bs7 {
  border-spacing: 0 28px;
}

.ua-ncss .bs8 {
  border-spacing: 0 32px;
}

.ua-ncss .bs9 {
  border-spacing: 0 36px;
}

.ua-ncss .bs10 {
  border-spacing: 0 40px;
}

.ua-ncss .bs11 {
  border-spacing: 0 44px;
}

.ua-ncss .bs12 {
  border-spacing: 0 48px;
}

.ua-ncss .z0 {
  z-index: 0;
}

.ua-ncss .z1 {
  z-index: 1;
}

.ua-ncss .z2 {
  z-index: 2;
}

.ua-ncss .z3 {
  z-index: 3;
}

.ua-ncss .z4 {
  z-index: 4;
}

.ua-ncss .z5 {
  z-index: 5;
}

.ua-ncss .z6 {
  z-index: 6;
}

.ua-ncss .z7 {
  z-index: 7;
}

.ua-ncss .z8 {
  z-index: 8;
}

.ua-ncss .z9 {
  z-index: 9;
}

.ua-ncss .z10 {
  z-index: 10;
}

.ua-ncss .text-color-black {
  color: #111;
}

.ua-ncss .text-color-white {
  color: #fff;
}

.ua-ncss .text-color-offwhite {
  color: #f7f7f7;
}

.ua-ncss .text-color-grey {
  color: #6d6d6d;
}

.ua-ncss .text-color-dark-grey {
  color: #222;
}

.ua-ncss .text-color-light-grey {
  color: #e5e5e5;
}

.ua-ncss .text-color-medium-grey {
  color: #ddd;
}

.ua-ncss .text-color-accent {
  color: #fa5400;
}

.ua-ncss .text-color-error {
  color: #fe0000;
}

.ua-ncss .text-color-success {
  color: #48bd1f;
}

.ua-ncss .bg-black {
  background: #111;
}

.ua-ncss .bg-white {
  background: #fff;
}

.ua-ncss .bg-offwhite {
  background: #f7f7f7;
}

.ua-ncss .bg-grey {
  background: #6d6d6d;
}

.ua-ncss .bg-dark-grey {
  background: #222;
}

.ua-ncss .bg-light-grey {
  background: #e5e5e5;
}

.ua-ncss .bg-medium-grey {
  background: #ddd;
}

.ua-ncss .bg-accent {
  background: #fa5400;
}

.ua-ncss .bg-error {
  background: #fe0000;
}

.ua-ncss .bg-success {
  background: #48bd1f;
}

.ua-ncss .border-top-black {
  -webkit-box-shadow: inset 0 1px 0 0 #111;
  box-shadow: inset 0 1px 0 0 #111;
}

.ua-ncss .border-right-black {
  -webkit-box-shadow: inset -1px 0 0 0 #111;
  box-shadow: inset -1px 0 0 0 #111;
}

.ua-ncss .border-bottom-black {
  -webkit-box-shadow: inset 0 -1px 0 0 #111;
  box-shadow: inset 0 -1px 0 0 #111;
}

.ua-ncss .border-left-black {
  -webkit-box-shadow: inset 1px 0 0 0 #111;
  box-shadow: inset 1px 0 0 0 #111;
}

.ua-ncss .border-black {
  -webkit-box-shadow: inset 0 1px 0 0 #111, inset -1px 0 0 0 #111, inset 0 -1px 0 0 #111, inset 1px 0 0 0 #111;
  box-shadow: inset 0 1px 0 0 #111, inset -1px 0 0 0 #111, inset 0 -1px 0 0 #111, inset 1px 0 0 0 #111;
}

.ua-ncss .border-top-white {
  -webkit-box-shadow: inset 0 1px 0 0 #fff;
  box-shadow: inset 0 1px 0 0 #fff;
}

.ua-ncss .border-right-white {
  -webkit-box-shadow: inset -1px 0 0 0 #fff;
  box-shadow: inset -1px 0 0 0 #fff;
}

.ua-ncss .border-bottom-white {
  -webkit-box-shadow: inset 0 -1px 0 0 #fff;
  box-shadow: inset 0 -1px 0 0 #fff;
}

.ua-ncss .border-left-white {
  -webkit-box-shadow: inset 1px 0 0 0 #fff;
  box-shadow: inset 1px 0 0 0 #fff;
}

.ua-ncss .border-white {
  -webkit-box-shadow: inset 0 1px 0 0 #fff, inset -1px 0 0 0 #fff, inset 0 -1px 0 0 #fff, inset 1px 0 0 0 #fff;
  box-shadow: inset 0 1px 0 0 #fff, inset -1px 0 0 0 #fff, inset 0 -1px 0 0 #fff, inset 1px 0 0 0 #fff;
}

.ua-ncss .border-top-offwhite {
  -webkit-box-shadow: inset 0 1px 0 0 #f7f7f7;
  box-shadow: inset 0 1px 0 0 #f7f7f7;
}

.ua-ncss .border-right-offwhite {
  -webkit-box-shadow: inset -1px 0 0 0 #f7f7f7;
  box-shadow: inset -1px 0 0 0 #f7f7f7;
}

.ua-ncss .border-bottom-offwhite {
  -webkit-box-shadow: inset 0 -1px 0 0 #f7f7f7;
  box-shadow: inset 0 -1px 0 0 #f7f7f7;
}

.ua-ncss .border-left-offwhite {
  -webkit-box-shadow: inset 1px 0 0 0 #f7f7f7;
  box-shadow: inset 1px 0 0 0 #f7f7f7;
}

.ua-ncss .border-offwhite {
  -webkit-box-shadow: inset 0 1px 0 0 #f7f7f7, inset -1px 0 0 0 #f7f7f7, inset 0 -1px 0 0 #f7f7f7, inset 1px 0 0 0 #f7f7f7;
  box-shadow: inset 0 1px 0 0 #f7f7f7, inset -1px 0 0 0 #f7f7f7, inset 0 -1px 0 0 #f7f7f7, inset 1px 0 0 0 #f7f7f7;
}

.ua-ncss .border-top-grey {
  -webkit-box-shadow: inset 0 1px 0 0 #6d6d6d;
  box-shadow: inset 0 1px 0 0 #6d6d6d;
}

.ua-ncss .border-right-grey {
  -webkit-box-shadow: inset -1px 0 0 0 #6d6d6d;
  box-shadow: inset -1px 0 0 0 #6d6d6d;
}

.ua-ncss .border-bottom-grey {
  -webkit-box-shadow: inset 0 -1px 0 0 #6d6d6d;
  box-shadow: inset 0 -1px 0 0 #6d6d6d;
}

.ua-ncss .border-left-grey {
  -webkit-box-shadow: inset 1px 0 0 0 #6d6d6d;
  box-shadow: inset 1px 0 0 0 #6d6d6d;
}

.ua-ncss .border-grey {
  -webkit-box-shadow: inset 0 1px 0 0 #6d6d6d, inset -1px 0 0 0 #6d6d6d, inset 0 -1px 0 0 #6d6d6d, inset 1px 0 0 0 #6d6d6d;
  box-shadow: inset 0 1px 0 0 #6d6d6d, inset -1px 0 0 0 #6d6d6d, inset 0 -1px 0 0 #6d6d6d, inset 1px 0 0 0 #6d6d6d;
}

.ua-ncss .border-top-dark-grey {
  -webkit-box-shadow: inset 0 1px 0 0 #222;
  box-shadow: inset 0 1px 0 0 #222;
}

.ua-ncss .border-right-dark-grey {
  -webkit-box-shadow: inset -1px 0 0 0 #222;
  box-shadow: inset -1px 0 0 0 #222;
}

.ua-ncss .border-bottom-dark-grey {
  -webkit-box-shadow: inset 0 -1px 0 0 #222;
  box-shadow: inset 0 -1px 0 0 #222;
}

.ua-ncss .border-left-dark-grey {
  -webkit-box-shadow: inset 1px 0 0 0 #222;
  box-shadow: inset 1px 0 0 0 #222;
}

.ua-ncss .border-dark-grey {
  -webkit-box-shadow: inset 0 1px 0 0 #222, inset -1px 0 0 0 #222, inset 0 -1px 0 0 #222, inset 1px 0 0 0 #222;
  box-shadow: inset 0 1px 0 0 #222, inset -1px 0 0 0 #222, inset 0 -1px 0 0 #222, inset 1px 0 0 0 #222;
}

.ua-ncss .border-top-light-grey {
  -webkit-box-shadow: inset 0 1px 0 0 #e5e5e5;
  box-shadow: inset 0 1px 0 0 #e5e5e5;
}

.ua-ncss .border-right-light-grey {
  -webkit-box-shadow: inset -1px 0 0 0 #e5e5e5;
  box-shadow: inset -1px 0 0 0 #e5e5e5;
}

.ua-ncss .border-bottom-light-grey {
  -webkit-box-shadow: inset 0 -1px 0 0 #e5e5e5;
  box-shadow: inset 0 -1px 0 0 #e5e5e5;
}

.ua-ncss .border-left-light-grey {
  -webkit-box-shadow: inset 1px 0 0 0 #e5e5e5;
  box-shadow: inset 1px 0 0 0 #e5e5e5;
}

.ua-ncss .border-light-grey {
  -webkit-box-shadow: inset 0 1px 0 0 #e5e5e5, inset -1px 0 0 0 #e5e5e5, inset 0 -1px 0 0 #e5e5e5, inset 1px 0 0 0 #e5e5e5;
  box-shadow: inset 0 1px 0 0 #e5e5e5, inset -1px 0 0 0 #e5e5e5, inset 0 -1px 0 0 #e5e5e5, inset 1px 0 0 0 #e5e5e5;
}

.ua-ncss .border-top-medium-grey {
  -webkit-box-shadow: inset 0 1px 0 0 #ddd;
  box-shadow: inset 0 1px 0 0 #ddd;
}

.ua-ncss .border-right-medium-grey {
  -webkit-box-shadow: inset -1px 0 0 0 #ddd;
  box-shadow: inset -1px 0 0 0 #ddd;
}

.ua-ncss .border-bottom-medium-grey {
  -webkit-box-shadow: inset 0 -1px 0 0 #ddd;
  box-shadow: inset 0 -1px 0 0 #ddd;
}

.ua-ncss .border-left-medium-grey {
  -webkit-box-shadow: inset 1px 0 0 0 #ddd;
  box-shadow: inset 1px 0 0 0 #ddd;
}

.ua-ncss .border-medium-grey {
  -webkit-box-shadow: inset 0 1px 0 0 #ddd, inset -1px 0 0 0 #ddd, inset 0 -1px 0 0 #ddd, inset 1px 0 0 0 #ddd;
  box-shadow: inset 0 1px 0 0 #ddd, inset -1px 0 0 0 #ddd, inset 0 -1px 0 0 #ddd, inset 1px 0 0 0 #ddd;
}

.ua-ncss .border-top-accent {
  -webkit-box-shadow: inset 0 1px 0 0 #fa5400;
  box-shadow: inset 0 1px 0 0 #fa5400;
}

.ua-ncss .border-right-accent {
  -webkit-box-shadow: inset -1px 0 0 0 #fa5400;
  box-shadow: inset -1px 0 0 0 #fa5400;
}

.ua-ncss .border-bottom-accent {
  -webkit-box-shadow: inset 0 -1px 0 0 #fa5400;
  box-shadow: inset 0 -1px 0 0 #fa5400;
}

.ua-ncss .border-left-accent {
  -webkit-box-shadow: inset 1px 0 0 0 #fa5400;
  box-shadow: inset 1px 0 0 0 #fa5400;
}

.ua-ncss .border-accent {
  -webkit-box-shadow: inset 0 1px 0 0 #fa5400, inset -1px 0 0 0 #fa5400, inset 0 -1px 0 0 #fa5400, inset 1px 0 0 0 #fa5400;
  box-shadow: inset 0 1px 0 0 #fa5400, inset -1px 0 0 0 #fa5400, inset 0 -1px 0 0 #fa5400, inset 1px 0 0 0 #fa5400;
}

.ua-ncss .border-top-error {
  -webkit-box-shadow: inset 0 1px 0 0 #fe0000;
  box-shadow: inset 0 1px 0 0 #fe0000;
}

.ua-ncss .border-right-error {
  -webkit-box-shadow: inset -1px 0 0 0 #fe0000;
  box-shadow: inset -1px 0 0 0 #fe0000;
}

.ua-ncss .border-bottom-error {
  -webkit-box-shadow: inset 0 -1px 0 0 #fe0000;
  box-shadow: inset 0 -1px 0 0 #fe0000;
}

.ua-ncss .border-left-error {
  -webkit-box-shadow: inset 1px 0 0 0 #fe0000;
  box-shadow: inset 1px 0 0 0 #fe0000;
}

.ua-ncss .border-error {
  -webkit-box-shadow: inset 0 1px 0 0 #fe0000, inset -1px 0 0 0 #fe0000, inset 0 -1px 0 0 #fe0000, inset 1px 0 0 0 #fe0000;
  box-shadow: inset 0 1px 0 0 #fe0000, inset -1px 0 0 0 #fe0000, inset 0 -1px 0 0 #fe0000, inset 1px 0 0 0 #fe0000;
}

.ua-ncss .border-top-success {
  -webkit-box-shadow: inset 0 1px 0 0 #48bd1f;
  box-shadow: inset 0 1px 0 0 #48bd1f;
}

.ua-ncss .border-right-success {
  -webkit-box-shadow: inset -1px 0 0 0 #48bd1f;
  box-shadow: inset -1px 0 0 0 #48bd1f;
}

.ua-ncss .border-bottom-success {
  -webkit-box-shadow: inset 0 -1px 0 0 #48bd1f;
  box-shadow: inset 0 -1px 0 0 #48bd1f;
}

.ua-ncss .border-left-success {
  -webkit-box-shadow: inset 1px 0 0 0 #48bd1f;
  box-shadow: inset 1px 0 0 0 #48bd1f;
}

.ua-ncss .border-success {
  -webkit-box-shadow: inset 0 1px 0 0 #48bd1f, inset -1px 0 0 0 #48bd1f, inset 0 -1px 0 0 #48bd1f, inset 1px 0 0 0 #48bd1f;
  box-shadow: inset 0 1px 0 0 #48bd1f, inset -1px 0 0 0 #48bd1f, inset 0 -1px 0 0 #48bd1f, inset 1px 0 0 0 #48bd1f;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
